export default {
  locale: 'en',
  messages: {
	accountMy: 'My account',
	actions: 'Actions',
	add: 'Add',
	addressAddNew: 'Add new address',
	addressCity: 'City',
	addressCountries: 'Country',
	addressCountry: 'Country',
	addressDeleteConfirmMessage: 'Are you sure you want to delete this address?',
	addressDeleteConfirmTitle: 'Delete an address',
	addressDeleteSuccess: 'Address deleted!',
	addressEdit: 'Edit an address',
	addressFlags: 'Flags',
	addressInvoice: 'Billing address',
	addressInvoiceDifferentAsShippingLabel: 'Is the billing data the same as the delivery address?',
	addressInvoiceSelectionTitle: 'Select your billing address',
	addressInvoiceUsedFor: 'Used for the invoice',
	addressInvoiceUse: 'Use for invoice',
	addressLabel: 'Label (ex: My home)',
	addressLegalInformation: 'Legal information',
	addressMy: 'My addresses',
	addressName: 'First name and last name',
	addressNoItems: 'You have not registered an address yet!',
	addressPhone: 'Phone (useful for delivery)',
	addressPostalCode: 'Postal code',
	addressRegion: 'State / Province',
	addressShipping: 'Delivery address',
	addressShippingSelectionTitle: 'Select your delivery address',
	addressStreet1: 'Address',
	addressCustomsHint: 'Required for customs clearance of your parcel.',
	addressStreetNumberHint: 'Remember the street number: without it the carrier often fails to find the address.',
	addressPostalCodeInvalid: 'This postal code does not match the selected country.',
	addressPhoneInvalid: 'This phone number seems incorrect. The carrier uses it to reach you.',
	addressPhoneMobileHint: 'A mobile number is recommended: the carrier sends the delivery notice by SMS.',
	addressIssueTitle: 'This address must be completed before shipping',
	addressIssueIncomplete: 'Some required fields are missing.',
	addressIssuePostalCode: 'Check the postal code for the selected country.',
	addressIssuePhone: 'A reachable phone number is required: the carrier calls you or sends the delivery notice.',
	addressIssueRegion: 'Select the state or province required by the carrier.',
	addressIssueTaxId: 'Customs require a tax ID for this destination.',
	addressIssueComplete: 'Complete this address',
	addressTaxIdRfc: 'Mexican tax ID (RFC)',
	addressTaxIdCpf: 'Brazilian tax ID (CPF)',
	addressTaxIdRut: 'Chilean tax ID (RUT)',
	addressTaxIdPccc: 'Personal Customs Clearance Code (PCCC)',
	addressTaxIdCuil: 'Argentine tax ID (CUIL)',
	addressTaxIdNationalId: 'National ID number',
	addressTaxIdNorwayNid: 'Norwegian national ID (11 digits)',
	shippingPickupSelectedHint: 'Pickup point selected. You can continue checkout.',
	shippingPickupMapUnavailable: 'Map unavailable for these pickup points. Please use the list view.',
	shippingPickupSelectedLabel: 'Pickup point',
	shippingPickupNoResultHomeHint: 'No pickup point found near this location. Try another postal code, or choose home delivery above.',
	shippingPickupErrorHomeHint: 'We could not load pickup points. Please retry, or choose home delivery above.',
	shippingProviderSendcloudInfoDefault: 'Home delivery. Manufacturing takes about 2 working days (Mon-Fri, excluding French public holidays), then carrier transit. The final carrier is selected at label creation.',
	shippingProviderSendcloudPickupInfoDefault: 'Choose a nearby pickup point. Manufacturing takes about 2 working days (Mon-Fri, excluding French public holidays), then carrier transit. The final carrier is selected at label creation.',
	shippingLabelGenerateError: 'Label generation failed. Check the address, pickup point and Sendcloud credentials, then retry.',
	shippingSendcloudPickLog: 'Sendcloud method used',
	shippingSendcloudMethodOverride: 'Sendcloud carrier (label)',
	shippingSendcloudMethodAuto: 'Automatic (best match)',
	shippingSendcloudMethodOverrideHint: 'Leave automatic, or force another Sendcloud method before generating the label.',
	orderShippingManualFlag: 'No carrier from our contracts matches this destination (country, weight or pickup point). Choose a Sendcloud method below, then generate the label.',
	shippingLegacyChronopostPaused: 'This order still uses the previous Chronopost setup. Switch the delivery method to a Sendcloud offer with Edit, then generate the label.',
	orderShippingFedexPickupFlag: 'FedEx shipment: pickup will be booked automatically between 6pm and 9pm Paris time for the next business day.',
	orderShippingFedexPickupBookedFlag: 'FedEx pickup booked for {date} (Sendcloud #{id}).',
	shippingSurchargeCorsica: 'This price includes a {price} Corsica surcharge.',
	shippingSurchargeOverseas: 'This price includes a {price} overseas surcharge.',
	shippingSurchargeRemote: 'This price includes a {price} remote area surcharge.',
	orderWeightHint: 'Total = unit weight × quantity ({quantity} items → {weight} kg)',
	orderWeightHintPages: 'Estimated from pages ({grams} g/page): {pages} pages → {weight} kg',
	shippingDeliveryApproxOn: 'Around {date}',
	shippingDeliveryApproxBetween: 'Between {date1} and {date2}',
	addressStreet2: 'Apartment number, digital code, intercom, ...',
	administrationTitle: 'Administration',
	affiliation: 'Affiliation',
	affiliationComment: 'Comment',
	affiliationCommission: 'Commission',
	affiliationCommissionMultiplePendingAlert: 'This list is an estimate: Orders & commissions are not consolidated!',
	affiliationCommissionPendingAlert: 'This order is awaiting validation',
	affiliationDeleteConfirmMessage: 'Are you sure you want to delete this affiliation?',
	affiliationInvoiceTotalAdminTitle: 'Total including tax to pay',
	affiliationInvoiceTotalTitle: 'Total including VAT to be collected',
	affiliationKey: 'Affiliation key',
	affiliationLegalApplyVAT: 'Apply VAT?',
	affiliationLegalInformations: 'Legal information (billing, Siret, ...)',
	affiliationMy: 'My affiliations',
	affiliationOptionValidityDays: 'Validity of the affiliate link (days)',
	affiliationSince: 'Member since',
	affiliationViewResultsMy: 'See affiliate recipes',
	affiliations: 'Affiliations',
	alertContactError: 'Unable to send your message! Please retry...',
	alertContactSuccess: 'Well received!',
	alertConversationNoExists: 'This conversation does not exist!',
	alertFetchApiError: 'The server is currently out of service...',
	alertFormRequiredFieldsError: 'Please fill all required fields!',
	alertGenericError: 'An error occured! Please contact us to solve your problem',
	alertInstitutionAlreadyExists: 'This institution already exists!',
	alertJsonParseError: 'The server returned a wrong response...',
	alertOrderValid: 'Your order is ready to be prepared!',
	alertUnauthorized: 'Your session expired! Please login to your account.',
	alertUserAlreadyExists: 'An account is already associated to this email!',
	alertUserRegisterSuccess: 'Welcome!',
	app404ErrorText: "We can't find what you're looking for! Return to the home page or to your account",
	app404ErrorTitle: 'Wrong route...',
	appAccessButton: 'Access {app}',
	appAgreementAcceptButton: 'Read the general conditions of use',
	appAgreementAcceptHelp: 'You can read the conditions by clicking on this link',
	appAgreementAcceptClickHint: 'Click here to check and accept',
	appAgreementAcceptLabel: 'I have read and accept the general conditions',
	appApplication: 'Application',
	appBackHomeButton: 'Return to home',
	appBackHomeTitle: 'Wrong route...',
	appBugErrorText: 'A problem has occurred.... SORRY! Please click on the link below to reload this page...',
	appConditionsAcceptTitle: 'General conditions of use',
	appConditionsCheckError: 'Please check that you have read the general conditions of use!',
	appConditionsCheckLabel: 'I have read and accept the general conditions of use',
	appConditionsCheckSuccess: 'Well received !',
	appConditionsUpdateDate: 'Updated on {date}',
	appConfig: 'Config',
	appConfiguration: 'Configuration',
	appCookieConsentPrivacyLink: 'Read our privacy policy',
	appCookieConsentText: 'By continuing to browse this site, you accept the use of cookies for the purposes of the proper functioning of the service offered and for statistics. No personal data will be communicated without your prior consent.',
	appCreateIndexButton: 'Create the database index',
	appDataPrivacyCheckButton: 'Read our data protection policy',
	appDatabase: 'Database',
	appErrorAlertText: 'An error has occurred, please try again later.',
	appErrorAlertTitle: 'An error has occurred!',
	appForceUpdateApp: 'Force app update',
	appForceUpdateAppWeb: 'Force web app update',
	appHome: 'Home',
	appMaintenanceModeText: 'Please wait a moment and check back in a few...',
	appMaintenanceModeTitle: 'We are undergoing maintenance',
	appProcessLaunch: 'Launch process',
	appQuestionLink: 'Questions?',
	appRewiewsHeaderText: 'Made in France 🇫🇷 with Love ❤️ - 4.6 ⭐️ ⭐️ ⭐️ ⭐️ ⭐️ +500 Trustpilot reviews',
	appShopOrderHistory: 'Order tracking',
	appStart: 'Create your book',
	appVersion: 'Version',
	appVersionCurrent: 'Current version of the application: {version}',
	appWebsiteAboutUs: 'About us',
	appWebsiteBlog: 'Blog',
	appWebsiteBook: 'The book',
	appWebsiteConversationAndroid: 'Text Messages Android',
	appWebsiteConversationInstagram: 'Instagram',
	appWebsiteConversationIos: 'Text Messages iPhone',
	appWebsiteConversationMessenger: 'Messenger',
	appWebsiteConversationWhatsapp: 'WhatsApp',
	appWebsiteConversations: 'Choice of Messaging',
	appWebsiteFaq: 'FAQ',
	appFooterQuestion: 'Got a question?',
	appFooterTerms: 'Terms of use',
	appWebsitePrices: 'Prices',
	appWelcomeTitle: 'Welcome to {name}',
	apply: 'Apply',
	autocompleteSearch: 'Type to search…',
	back: 'Back',
	by: 'by',
	cancel: 'Cancel',
	cartAddTo: 'Add to cart',
	cartAuthInfo: 'Please fill in your email to continue...',
	cartContinuePurchase: 'Continue shopping',
	cartEmptyError: 'Your cart is empty...',
	cartItemsRemoveAll: 'Delete all',
	cartMy: 'My cart',
	cartMyEdit: 'Edit my cart',
	cartNextStepButton: 'Go to the next step',
	cartNoItems: 'There are no items in your cart. .',
	cartNote: 'Note',
	cartProgression: 'Basket progress',
	cartSalesConditionsAccept: 'By confirming your order you accept our terms of sale.',
	cartSee: 'View my cart',
	cartShipping: 'Delivery',
	cartShippingFeeError: 'We cannot deliver to this address! Please provide another address!',
	cartStepConfirmationTitle: 'Confirmation',
	cartStepInvoiceTitle: 'Billing',
	cartStepPaymentTitle: 'Payment',
	cartStepPreviewTitle: 'Cart',
	cartStepShippingTitle: 'Delivery',
	cartTotalShipping: 'Shipping costs',
	cartTotalSubTotal: 'Subtotal',
	cartTotalTax: 'VAT',
	cartTotalTotal: 'Total',
	cartValidButton: 'Confirm my order',
	checkoutEyebrow: 'Your order',
	checkoutStepUpsellTitle: 'One copy, or two?',
	checkoutStepUpsellTitleGroup: 'One copy, two? Or more?',
	checkoutStepUpsellHint: 'Keep one for yourself, gift one to a loved one, or both.',
	checkoutStepUpsellHintGroup: 'One for everyone: discount from the second copy.',
	checkoutStepShippingTitle: 'Where should we send your book?',
	checkoutStepShippingHint: 'We print it with care and ship it worldwide.',
	checkoutStepInvoiceTitle: 'Your details',
	checkoutStepInvoiceHint: 'For your invoice and order tracking.',
	checkoutStepPaymentTitle: 'Pay securely',
	checkoutStepPaymentHint: 'Credit card, Apple Pay, Google Pay: encrypted payment.',
	checkoutPdfReadyTitle: 'Your eBook is ready',
	checkoutPdfReadyHint: 'No delivery needed, just finalize your order.',
	checkoutSummaryEyebrow: 'Summary',
	cartReassuranceSecure: 'Secure payment',
	cartReassuranceReturn: 'Money-back guarantee',
	cartReassuranceSupport: 'Customer support',
	checkoutPromoEyebrow: 'Promo code',
	checkoutGiftEyebrow: 'Gift card',
	checkoutGiftCodeLabel: 'Gift code',
	checkoutGiftCodePlaceholder: 'Enter your gift code',
	checkoutGiftCodeHint: 'Received a gift card? Enter your code here.',
	checkoutGiftToggle: 'Have a gift card?',
	checkoutAddCopy: 'Add another copy',
	checkoutSecondCopyKicker: 'For you, or to give',
	checkoutSecondCopyKickerGroup: 'One for each of you',
	checkoutSecondCopyTitle: 'The extra copy, half price',
	checkoutSecondCopyTitlePercent: 'The extra copy',
	checkoutSecondCopyFor: 'this copy',
	checkoutSecondCopyForGroup: 'the 2nd',
	checkoutSecondCopyChip: '2nd at half price',
	checkoutSecondCopyChipPercent: '2nd, {percent}% off',
	checkoutSecondCopySet: 'All {count} volumes, together',
	checkoutSecondCopyPerBook: 'each book',
	checkoutSecondCopySetPrice: '{price} for all {count} volumes',
	checkoutExtraBooksChip: 'extra books at half price',
	checkoutExtraBooksChipPercent: 'extra books at −{percent}%',
	checkoutGroupQtyHint: 'The 3rd too: every extra book at −{percent}%.',
	productExtraCopyRate: 'Extra books, as a % of one book',
	productExtraCopyRateHelp: 'Each book after the first copy is this percent of the single-book price. Empty: 50%. 0: quantity tiers.',
	checkoutGroupPicksLabel: 'Copies',
	checkoutGroupAddSecond: '2nd',
	checkoutGroupAddThird: '3',
	checkoutGroupAddSecondAria: 'Add the second copy at half price',
	checkoutGroupAddThirdAria: 'Switch to three copies',
	checkoutQtyGroupHint: 'One for each of you: the discount starts at the second copy.',
	checkoutQtyPdfSingle: '1 eBook',
	checkoutQtyMoreAriaLabel: 'Other quantity',
	checkoutQtyVolumeBreakdown: '{copies} copies × {volumes} volumes = {total} books',
	checkoutOfferBookCount: '{count, plural, one {# book} other {# books}}',
	checkoutUpsellTwoHint: 'Perfect for gifting: add a second copy, the discount applies automatically.',
	checkoutEmptyTitle: 'No order in progress',
	checkoutEmptyHint: 'Go back to your book to choose your edition.',
	checkoutEmptyCta: 'See my conversations',
	checkoutBookAsideEyebrow: 'Your book',
	checkoutBookAsideEyebrowPlural: 'Your books',
	checkoutBookAsideVolume: 'volume',
	checkoutBookAsideVolumes: 'volumes',
	checkoutBookAsideShelfLabel: 'The {count} volumes in your order',
	checkoutBookAsideEbook: 'eBook',
	checkoutBookAsidePaper: 'Printed book',
	checkToggler: 'Select/Deselect all',
	choose: 'Choose',
	close: 'Close',
	cms: 'CMS',
	cmsAdminListHint: 'Edit pages, panels and translations. Flags show translation status per language.',
	cmsContentDuplicateSuccess: 'CMS content duplicated!',
	cmsContentEdit: 'Edit Content',
	cmsContentModelLabel: 'Content Template',
	cmsContentSlug: 'Slug',
	cmsContentTitle: 'Title',
	cmsContentTypeLabel: 'Content Type',
	cmsDeleteConfirmMessage: 'Are you sure you want to delete this content?',
	cmsDeleteConfirmTitle: 'Delete content',
	cmsImageUseForMobile: 'Used for mobile viewing?',
	cmsLinkColor: 'Button color',
	cmsLinkNeedObfuscate: 'Need obfuscation?',
	cmsPageAdd: 'Add a page',
	cmsPageIsActive: 'Is active ?',
	cmsPageSeoDescription: 'SEO Description',
	cmsPageSeoHideOnSitemap: 'Hide on the sitemap',
	cmsPageSeoKeywords: 'SEO Keywords',
	cmsPageSeoTitle: 'SEO Title',
	cmsPageSeoTitleSuffix: 'Title suffix',
	cmsPageSeoUseCustomTitleSuffix: 'Use a custom title suffix',
	cmsPanelIsTemplate: 'Included in template?',
	cmsRedirectionAdd: 'Add Redirect',
	code: 'Code',
	companyShippingEdit: 'Change transport',
	conditions: 'Conditions',
	configAdminHint: 'Application settings, affiliations, background processes and raw configuration keys.',
	configMissingKeyAlert: 'The configuration key property is missing!',
	configuration: 'Configuration',
	confirm: 'Confirm',
	confirmMessage: 'Please confirm your action.',
	confirmTitle: 'Are you sure?',
	console: 'Console',
	contactButton: 'Contact us',
	contactMessage: 'Message',
	contactPageButton: 'Send',
	contactPageText1: 'Need help? Information? We are here to help you!',
	contactPageTitle: 'Contact us',
	contactSend: 'Send',
	contentEditPage: 'Edit Page',
	continue: 'Continue',
	conversationActionContinue: 'Continue',
	conversationActionRestart: 'Start again',
	conversationAddTitle: 'Create a book',
	conversationAdminDeleteConfirmMessage: 'This conversation and all its media will be permanently deleted. This action cannot be undone.',
	conversationAdminDeleteConfirmTitle: 'Delete conversation',
	conversationAdminListHint: 'Browse, filter and manage all customer conversations. Use status tabs to target a funnel step.',
	conversationArchiveError: 'We can not read your archive file! Please contact us to solve the problem...',
	conversationBackToList: 'Back to my conversations',
	conversationBookBackToCover: 'Back to cover',
	conversationBookFormat: 'Book format',
	conversationBookNavNext: 'Next page',
	conversationBookNavPrev: 'Previous page',
	conversationBookOrderTypeBook: 'Book + free eBook(s)',
	conversationBookOrderTypePdf: 'eBook(s) only',
	conversationBookPreview: 'Preview',
	conversationBookPreviewSelected: 'Preview book #{number}',
	conversationBookSelector: 'Select the book to edit',
	conversationBookTypeLabelBook: 'Paper book + ebook',
	conversationBookTypeLabelPdf: 'Ebook only',
	conversationBooks: 'Books',
	conversationCollectorArchiveSelectButton: 'Upload an archive',
	conversationCollectorInitWaiting: 'We are initializing some data... Please wait',
	conversationCollectorUseArchive: 'Upload a data backup (archive)',
	conversationCoverApplyOptionColor: 'Color',
	conversationCoverApplyOptionPhoto: 'Photo',
	conversationCoverApplyOptionSubtitle: 'Subtitle',
	conversationCoverApplyOptionTitle: 'Title',
	conversationCoverApplyToAllBooks: 'Apply this cover to all volumes',
	conversationCoverAutoAppliedToAllBooks: 'Cover applied to the other volumes.',
	conversationCoverApplyToAllBooksMessage: 'Choose the elements to apply to every other volume.',
	conversationCoverApplyToAllBooksTitle: 'Apply this cover to all volumes?',
	conversationCoverBookEdit: 'Customise your cover',
	conversationCoverBookNumber: 'Book {number}',
	conversationCoverBookReset: 'Reset the cover of this book',
	conversationCoverBookSwitchAlertMessage: 'Your cover information for this book will be saved.',
	conversationCoverBookSwitchAlertTitle: 'Do you want to save your cover?',
	conversationCoverColorEditTitle: 'Cover choice',
	conversationCoverColorSelectorHelp: 'Choose cover color',
	conversationCoverStyleSelectorHelp: 'Choose the cover style',
	conversationCoverStylePhoto: 'Polaroid',
	conversationCoverStyleIncipit: 'First message',
	conversationCoverPickMessageTitle: 'Choose a message',
	conversationCoverEditQuote: 'Edit the line',
	conversationCoverPickMessageHint: 'This line shows up large on the cover.',
	conversationCoverPickMessageSearch: 'Search a message',
	conversationCoverPickMessageEmpty: 'No message matches.',
	conversationCoverAddQuote: 'Add a line',
	conversationCoverHourLabel: 'Time',
	conversationCoverDateLabel: 'Date',
	conversationCoverGroupNameLabel: 'Group name',
	conversationCoverSpanLabel: 'First and last message dates',
	conversationCoverApplyOptionStyle: 'Style',
	conversationCoverApplyOptionQuote: 'Opening line',
	conversationCoverDefaultTitleGroup: 'Our group',
	conversationCoverDefaultTitleSingle: 'My messages',
	conversationCoverDefaultTitleTwoNames: '{name1} & {name2}',
	conversationCoverDragNDropFiles: 'Drag/Drop an image here',
	conversationCoverTapToSelectPhoto: 'Tap to choose a photo',
	conversationCoverEditionTypeBookHelp: 'In full collection mode, you can customize each volume cover one by one.',
	conversationCoverEditionTypeTitle: 'Book edition type',
	conversationCoverFooterBackToCover: 'Back to cover',
	conversationCoverFooterFinishPreview: 'Done · back to preview',
	conversationCoverFooterGoPreview: 'Back to preview',
	conversationCoverFooterNextPreface: 'Optional preface',
	conversationCoverFooterPrefaceGuide: 'Use Back to return to the preview without a preface, or continue to write an optional preface for the inside cover.',
	conversationCoverFooterSkipPreface: 'Skip preface · back to preview',
	conversationCoverLuxEyebrow: 'Your cover',
	conversationCoverLuxHint: 'Choose the style and color, then personalize the cover.',
	conversationCoverOpenFinder: 'Select an image',
	conversationCoverPhotoSelectorTitle: 'Choose a photo',
	conversationCoverPhotoEditHint: 'Click to change the photo',
	conversationCoverPhotoChoose: 'Click to choose a photo',
	conversationPreviewSwipeHint: 'Swipe to turn the pages',
	conversationPreviewOpenBookHint: 'Swipe the cover to open the book',
	conversationPreviewDiscoverBook: 'Discover my book',
	conversationPreviewVolumesLabel: 'Your collection: {count} books',
	conversationPreviewVolumesHint: 'Tap a cover to open that volume.',
	conversationCoverResumeEditTitle: 'Write a preface (optional)',
	conversationCoverResumeError: 'This preface is too long for one page. Shorten it, or use fewer line breaks.',
	conversationCoverResumeNearLimit: 'Approaching one-page limit ({lines}/{max} lines).',
	conversationCoverResumeHelp: 'This preface will be printed on the inside cover.',
	conversationCoverResumeLuxEyebrow: 'Preface',
	conversationCoverResumeLuxHint: 'Optional: this text is printed on the inside cover.',
	conversationCoverResumePlaceholder: 'Write a preface for your book',
	conversationCoverResumeReset: 'Reset this book\'s preface',
	conversationCoverTitleError: 'Title too long (max: {max} characters)',
	conversationCoverTitleHelp: 'Click to edit the book title',
	conversationCoverTitlePlaceholder: 'Enter a title...',
	conversationCoverWaitingForCustomization: 'You can personalize your cover in the next step...',
	conversationCreateInfoText: 'Create a new message book by clicking on the icons here',
	conversationCreateMyBookTitle: 'I create my book',
	conversationCreateTitle: 'Create a book',
	conversationCreationDate: 'Creation date',
	conversationCustomImportUpload: 'Import generated file',
	conversationDateCreation: 'Creation date',
	conversationDateDownloadedInfo: 'The book was downloaded on {downloaded}',
	conversationDateEnd: 'End of conversation',
	conversationDateEndInfo: 'The book ends {end}',
	conversationDateEndLabel: 'Select end date',
	conversationDateEndMessageSelection: 'End the book here',
	conversationDateGeneratedInfo: 'The book was generated on {generated}',
	conversationDateRange: 'From {start} to {end}',
	conversationDateSelectionAlert: 'It appears that your conversation was corrupted during the transfer. Please try again by remaining on the page during the transfer and having a good internet connection.',
	conversationDateSimulatedInfo: 'The book was viewed on {simulated}',
	conversationDateStart: 'Start of conversation',
	conversationDateStartInfo: 'The book begins on {start}',
	conversationDateStartLabel: 'Select start date',
	conversationDateStartMessageSelection: 'Start the book here',
	conversationDatesEditTitle: 'Date selection',
	conversationDatesLuxBackStart: 'Start date',
	conversationDatesLuxEyebrow: 'Your story',
	conversationDatesLuxHint: 'Choose the start and end dates of your book. Click a message to refine the selection.',
	conversationDatesLuxNextEnd: 'End date',
	conversationDatesLuxSavePreview: 'Save · back to preview',
	conversationDatesPresetsLabel: 'Quick period selection',
	conversationDatesPreset_all: 'Entire conversation',
	conversationDatesPreset_year: 'Last year',
	conversationDatesPreset_sixMonths: 'Last 6 months',
	conversationDatesSelectionCount: '{count, number} {count, plural, one {message} other {messages}}',
	conversationDatesSelectionPeriod: 'from {start} to {end}',
	conversationDatesStoryDuration: 'This selection covers {duration}',
	conversationDatesStartCaption: 'Your very first message',
	conversationDatesEndCaption: 'Your very last message',
	conversationDatesBookMessages: '{messages, number} {messages, plural, one {message} other {messages}}, {photos, number} {photos, plural, one {photo} other {photos}} and {medias, number} {medias, plural, one {media file} other {media files}} in your selection',
	conversationDateSelectionEmpty: 'No messages in this date range. Try widening the selected period.',
	conversationDeleteConfirmation: 'Conversation has been deleted!',
	conversationDemoAlert: 'You will be able to discover the first pages of your book.<br></br>Once ordered, you will receive the complete version to check before printing.',
	conversationDemoEndAlert: 'You will be able to discover the rest of your messages after confirming your purchase.',
	conversationDisclaimerEBookIncluded: 'Ebook edition included',
	conversationDisclaimerGenerating: 'Generating your book in progress...',
	conversationDisclaimerPlanCollectionBadge: 'BUNDLE OFFER -{percentage}%',
	conversationDisclaimerPlanCollectionButtonText: 'Preserve our entire story',
	conversationDisclaimerPlanCollectionDescription: 'The Full Set',
	conversationDisclaimerPlanCollectionFeatureBox: 'Your {count} books printed & delivered',
	conversationDisclaimerPlanCollectionFeatureDigital: 'Digital edition included',
	conversationDisclaimerPlanCollectionFeatureDiscount: 'Collection price -{percentage}% (-{amount} included)',
	conversationDisclaimerPlanCollectionFeatureMedia: 'Photos, Videos & Audio included',
	conversationDisclaimerPlanCollectionFeatureWorkshop: 'Full customization included',
	conversationDisclaimerPlanCollectionTitle: 'The Complete Collection',
	conversationDisclaimerPlanEbookButtonText: 'Save as PDF',
	conversationDisclaimerPlanEbookDescription: 'Digital',
	conversationDisclaimerPlanEbookFeatureMedia: 'Photos, Videos & Audio included',
	conversationDisclaimerPlanEbookFeatureMessages: 'All your {count} messages',
	conversationDisclaimerPlanEbookFeaturePdf: 'Instant High Definition PDF',
	conversationDisclaimerPlanEbookFeatureShare: 'Easy sharing',
	conversationDisclaimerPlanEbookTitle: 'The Ebook Edition',
	conversationDisclaimerPlanSingleButtonText: 'Create my book',
	conversationDisclaimerPlanSingleDescription: 'The Essential',
	conversationDisclaimerPlanSingleFeatureEvolutive: 'Scalable: complete the series later',
	conversationDisclaimerPlanSingleFeatureMedia: 'Photos, Videos & Audio included',
	conversationDisclaimerPlanSingleFeaturePages: 'The book of your choice (400 pages) delivered',
	conversationDisclaimerPlanSingleFeaturePdfIncluded: 'PDF Included ({price})',
	conversationDisclaimerPlanSingleFeaturePremiumPaper: 'Papier Premium',
	conversationDisclaimerPlanSingleFeaturePremiumPrint: 'Premium Print',
	conversationDisclaimerPlanSingleFeatureQuality: '',
	conversationDisclaimerPlanSingleFeatureWorkshop: 'Full customization included',
	conversationDisclaimerPlanSingleTitle: 'Volume 1',
	conversationDisclaimerReassuranceCustomDescription: 'Edit cover and messages after payment',
	conversationDisclaimerReassuranceCustomTitle: 'Free Customization',
	conversationDisclaimerReassuranceDeliveryDescription: 'Delivery in 5 business days',
	conversationDisclaimerReassuranceDeliveryTitle: 'Fast Delivery',
	conversationDisclaimerReassuranceGuaranteeDescription: 'Refund on simple request until final validation.',
	conversationDisclaimerReassuranceGuaranteeTitle: 'Satisfaction Guarantee',
	conversationDisclaimerReassuranceSecureDescription: 'Credit card, Apple Pay, Google Pay, Link',
	conversationDisclaimerReassuranceSecureTitle: '100% Secure Payment',
	conversationDisclaimerReviewSuffix: 'on +{count} printed books',
	conversationDisclaimerSavings: 'You save {value}',
	conversationDisclaimerSubtitle: 'Choose your format to access your customization workshop.',
	conversationDisclaimerTitle: `{count} {count, plural,
		=0 {message}
		=1 {message}
		other {messages}
	}: a story worth reading`,
	conversationDowloadUnableAlert: 'You can no longer download conversation books... Contact us to resolve your problem.',
	conversationDownloadBackPreview: 'Back to book preview',
	conversationDownloadDeadlineInfo: 'You can download your files until {date}',
	conversationDownloadEyebrow: 'Your book is ready',
	conversationDownloadFileCoverLink: 'Download cover {name}',
	conversationDownloadFileSourceLink: 'Download source {name}',
	conversationDownloadHint: 'Download your PDF and keep a digital copy of your conversation.',
	conversationDownloadLink: 'Download my book N°{index}',
	conversationDownloadLoading: 'Preparing your files…',
	conversationDownloadPdfButton: 'Download the E-book',
	conversationDownloadPdfWaitingMessage: 'Wait 5 minutes to download again',
	conversationEditStart: 'Edit the book',
	conversationEditSuccess: 'Conversation has been edited!',
	conversationFlags: 'Flags',
	'conversationFormatLabelA4-1': 'Chronicles of your memories',
	'conversationFormatLabelA4-2': '(A4 album)',
	'conversationFormatLabelA5-1': 'The little treasure',
	'conversationFormatLabelA5-2': '(A5 notebook)',
	conversationGenerate: 'Generate the books',
	conversationGeneratedSuccess: 'Congratulations! <br></br> Your conversation has been generated!',
	conversationGenerationAlert: "We're crafting your book…",
	conversationGenerationAlert2: 'Stay with us, this only takes a moment.',
	conversationGenerationFailed: 'Something interrupted the layout of your book.',
	conversationGenerationFailedHint: 'Your messages are safe. Give it another try, and if it happens again, write to us and we\'ll look into it with you.',
	conversationGenerationRetry: 'Try again',
	conversationHelpBooksText: 'Switch between your books to edit their own information',
	conversationHelpBooksTitle: 'Book selection',
	conversationHelpCoverColorText: 'You can change cover background color by clicking on the circle.',
	conversationHelpCoverColorTitle: 'Cover color',
	conversationHelpCoverImageText: 'You can drag and drop any image file in this space to add it to your cover.',
	conversationHelpCoverImageTitle: 'Cover image',
	conversationHelpCoverTitleText: 'Click the title to edit it. You have 2 lines to change: title and subtitle.',
	conversationHelpCoverTitleTitle: 'Cover title',
	conversationHelpDatePreviewText: 'By changing the date, your first/last messages are shown here!',
	conversationHelpDatePreviewTitle: 'Message preview',
	conversationHelpDateSelectorText: 'Select the start date of your book.',
	conversationHelpDateSelectorTitle: 'Date',
	conversationHelpParticipantColorText: 'You can change the bubble color of each participant',
	conversationHelpParticipantColorTitle: 'Participant color',
	conversationHelpParticipantNameText: 'Edit participant\\',
	conversationHelpParticipantNameTitle: 'Participant name',
	conversationHelpParticipantPositionText: 'Choose if you prefer to display bubble\\',
	conversationHelpParticipantPositionTitle: 'Participant\\',
	conversationHelpMessagesToolsTitle: 'Tools',
	conversationHelpMessagesToolsText: 'Tap a tile to search, filter by media or dates, or hide messages.',
	conversationHelpMessagesSearchTitle: 'Search',
	conversationHelpMessagesSearchText: 'Type a word or a name to find a message quickly.',
	conversationHelpMessagesMediasTitle: 'Medias',
	conversationHelpMessagesMediasText: 'Filter messages that contain photos, videos, audios or links.',
	conversationHelpMessagesDatesTitle: 'Dates',
	conversationHelpMessagesDatesText: 'Keep only messages between two dates to focus on a part of the conversation.',
	conversationHelpMessagesHidePeriodTitle: 'Hide a period',
	conversationHelpMessagesHidePeriodText: 'Choose two dates to hide (or show again) a whole period at once.',
	conversationHelpMessagesHiddenTitle: 'Display',
	conversationHelpMessagesHiddenText: 'Show all messages, only visible ones, or only hidden ones.',
	conversationHelpMessagesListTitle: 'Edit a message',
	conversationHelpMessagesListText: 'On each bubble: select, hide, edit the text, or insert a new one.',
	conversationHelpMessagesFooterTitle: 'Back to preview',
	conversationHelpMessagesFooterText: 'When you are done, go back to the preview to see your updated book.',
	conversationHelpPreviewBookCoverText: 'Give it a cover that could only be yours. Click to customise it.',
	conversationHelpPreviewBookCoverTitle: 'Cover',
	conversationHelpPreviewBookPreviewText: 'Click to preview this book.',
	conversationHelpPreviewBookPreviewTitle: 'Book Preview',
	conversationHelpPreviewBookSelectorText: 'Select the volumes you would like to include in your order.',
	conversationHelpPreviewBookSelectorTitle: 'Your books',
	conversationHelpPreviewBookSplitText: 'By activating this option, each book will contain the same number of pages.',
	conversationHelpPreviewBookSplitTitle: 'Balance the pages',
	conversationHelpPreviewCopyText: 'Order extra copies — for you, or as a gift. Discount from the second one.',
	conversationHelpPreviewCopyTitle: 'Give a copy',
	conversationHelpPreviewCustomizeText: 'Tap a card to edit names, dates or messages.',
	conversationHelpPreviewCustomizeTitle: 'Names, dates and messages',
	conversationHelpPreviewFormatText: 'A printed book or an ebook: pick what feels right.',
	conversationHelpPreviewFormatTitle: 'Format',
	conversationHelpPreviewRenderText: 'Here\'s your book. Edit the cover right on it, then flip through the pages.',
	conversationHelpPreviewRenderTitle: 'Your book',
	conversationHelpPreviewMessagesText: 'Tap this card to edit the content of your messages.',
	conversationHelpPreviewMessagesTitle: 'Messages',
	conversationHelpPreviewDatesText: 'Tap this card to choose the start and end dates of your book.',
	conversationHelpPreviewDatesTitle: 'Dates',
	conversationHelpPreviewParticipantsText: 'Tap this card to change participant names and how they appear.',
	conversationHelpPreviewParticipantsTitle: 'Participants',
	conversationHelpPreviewCoverTitleText: 'Click the title or subtitle to edit them.',
	conversationHelpPreviewCoverTitleTitle: 'Title and subtitle',
	conversationHelpPreviewVolumesTitle: 'Several volumes',
	conversationHelpPreviewVolumesText: 'Your conversation spans several books. Tap a number to switch volumes and customize each cover.',
	conversationHelpPreviewCoverImageText: 'Tap the photo area to add or change the cover image.',
	conversationHelpPreviewCoverImageTitle: 'Photo',
	conversationHelpPreviewCoverColorText: 'Tap a swatch to change the cover background colour.',
	conversationHelpPreviewCoverColorTitle: 'Colour',
	conversationHelpPreviewValidText: 'When it feels right, confirm. The ebook lands in your inbox, the book at your door.',
	conversationHelpPreviewValidTitle: "Let's go!",
	conversationHighlightBadge: 'In a few numbers',
	conversationHighlightStoryKicker: 'Your story',
	conversationHighlightsMomentsCount: '{count, plural, one {# image to download} other {# images to download}}',
	conversationHighlightShareFormat: 'Story format',
	conversationHighlightCharsCountReferenceDiffDescription: 'The text of Romeo and Juliet, this many times over.',
	conversationHighlightCharsCountReferenceDiffRomeoJuliette: '{diff} times',
	conversationHighlightCharsCountReferenceDiffTitle: 'Romeo and Juliet',
	conversationHighlightDurationDescription: 'All these days together, since that first message.',
	conversationHighlightDurationTitle: 'Together since',
	conversationHighlightImagesCountDescription: 'Photos we saved from our chats.',
	conversationHighlightImagesCountTitle: 'Photos',
	conversationHighlightMediasCountDescription: 'To hear a voice again, and see that moment again.',
	conversationHighlightMediasCountTitle: 'Videos and voice notes',
	conversationHighlightMessagesCountDescription: 'All these messages, exchanged since {date}.',
	conversationHighlightMessagesCountTitle: 'Messages',
	conversationHighlightShareButton: 'Download',
	conversationHighlightShareButtonAlt: 'View conversation statistics',
	conversationHighlightShareImageButton: 'Send the image',
	conversationHighlightSpecialDayDescription: 'The day we wrote to each other the most.',
	conversationHighlightSpecialDayMessagesCountDescription: 'Our record: all these messages in a single day.',
	conversationHighlightSpecialDayMessagesCountTitle: 'In a single day',
	conversationHighlightSpecialDayTitle: 'That day',
	conversationHighlightStartDateDescription: 'That day, the first message went out. Everything else started there.',
	conversationHighlightStartDateTitle: 'The first message',
	conversationHighlightSubtitle: 'The numbers behind what you said to each other.',
	conversationHighlightTitle1: 'Your messages',
	conversationHighlightTitle2: 'in a few numbers',
	conversationHighlightTypingDurationDescription: 'All these hours we spent writing to each other.',
	conversationHighlightTypingDurationTitle: 'Time writing',
	conversationHighlightOpenStoryButton: 'Open this story',
	conversationHighlightsAtGlanceEyebrow: 'At a glance',
	conversationHighlightsAtGlanceTitle: 'The size of your story',
	conversationHighlightsNoAiNote: 'These statistics are calculated automatically, without AI.',
	conversationHighlightsKpiMessages: 'messages',
	conversationHighlightsKpiWords: 'words written',
	conversationHighlightsKpiActiveDays: 'active days',
	conversationHighlightsKpiStreak: 'days in a row',
	conversationHighlightsRhythmEyebrow: 'Your rhythm',
	conversationHighlightsRhythmTitle: 'When your messages come alive',
	conversationHighlightsTopHour: 'Favorite time',
	conversationHighlightsTopWeekday: 'Favorite day',
	conversationHighlightsNightMessages: 'Messages at night',
	conversationHighlightsChartMonths: 'Every month, from the first message to the last',
	conversationHighlightsChartYears: 'Every year, from the first message to the last',
	conversationHighlightsLessThanOneMinute: 'under 1 min',
	conversationHighlightsSpanLessThanMonth: 'Less than a month',
	conversationHighlightsSpanYears: '{count, plural, one {# year} other {# years}}',
	conversationHighlightsSpanMonths: '{count, plural, one {# month} other {# months}}',
	conversationHighlightsSpanYearsMonths: '{years, plural, one {# year} other {# years}} and {months, plural, one {# month} other {# months}}',
	conversationHighlightsSpanLabel: 'From the first message to the last',
	conversationHighlightsBusiestDayLabel: 'Busiest day',
	conversationHighlightsPhotosLabel: 'Photos',
	conversationHighlightsMediasLabel: 'Videos and voice notes',
	conversationHighlightsBookPagesLabel: 'Your book',
	conversationHighlightsBookPagesPrefix: 'about',
	conversationHighlightsBookPagesUnit: '{count, plural, one {page} other {pages}}',
	conversationHighlightsBookPagesNote: 'An estimate from your messages and photos.',
	conversationHighlightsWritingHours: 'About {count, plural, one {# hour spent writing to each other} other {# hours spent writing to each other}}.',
	conversationHighlightsRomeo: 'As much text as Romeo and Juliet, {count} times over.',
	conversationHighlightsDayClockPeak: 'Most often between {start} and {end}',
	conversationHighlightsLessThanOnePercent: '< 1%',
	conversationHighlightsWritesLonger: '{name} writes the longest messages.',
	conversationHighlightsStartsMore: '{name} most often starts the conversation.',
	conversationHighlightsWordsPerMessage: '{count} words / message',
	conversationHighlightsStartsShare: '{percent}% of starts',
	conversationHighlightsMedianReply: 'Median reply',
	conversationHighlightsBalanceEyebrow: 'Your balance',
	conversationHighlightsBalanceTitle: 'Everyone has their own way of being there',
	conversationHighlightsWordsShort: 'words',
	conversationHighlightsStartsShort: 'starts',
	conversationHighlightsBalanceNote: 'A percentage describes a rhythm, not the importance of a person.',
	conversationHighlightsRecordsEyebrow: 'Your records',
	conversationHighlightsRecordsTitle: 'The numbers to remember',
	conversationHighlightsLongestSession: 'Longest series of messages',
	conversationHighlightsIntenseQuarter: 'Record in 15 minutes',
	conversationHighlightsQuestions: 'Tender messages',
	conversationHighlightsSignsOfInterest: 'hearts, kisses or “I love you”',
	conversationHighlightsLaughs: 'Messages with laughter',
	conversationHighlightsSharedSmiles: 'haha, LOL or a laughing emoji',
	conversationHighlightsFavoriteEmojis: 'Your favorite emojis',
	conversationHighlightsStoriesEyebrow: 'To keep',
	conversationHighlightsStoriesTitle: 'Your story cards',
	conversationHighlightsStoriesText: 'Open a card, then download it in story format.',
	conversationHighlightsDeepEyebrow: 'And after the numbers?',
	conversationHighlightsDeepTitle: 'Would you like a deeper reading of your story?',
	conversationHighlightsDeepText: 'Tell us if you would like us to go further one day. Nothing else will be analyzed for now.',
	conversationHighlightsDeepThanks: 'Thank you, your interest is recorded',
	conversationHighlightsDeepButton: 'Yes, I would be interested',
	conversationHighlightsDeepNotice: 'You’ll be notified as soon as it’s planned.',
	conversationHighlightsDeepNoticeClose: 'All right',
	conversationHighlightsPrintBook: 'I want to print my book',
	conversationHighlightsPrintNow: 'Print it now',
	conversationHighlightUnitDays: '{count, plural, one {day} other {days}}',
	conversationHighlightUnitHours: '{count, plural, one {hour} other {hours}}',
	conversationHighlightUnitMessages: '{count, plural, one {message} other {messages}}',
	conversationHighlightUnitTimes: 'times',
	conversationHighlightsCardFooter: 'Some stories deserve a book',
	conversationHighlightsEmpty: 'Not enough messages yet to draw out the numbers.',
	conversationHighlightsLoading: 'Gathering your numbers.',
	conversationImages: 'Images',
	conversationImagesCount: '{count} photo(s)',
	conversationImportAcceptTermsToContinue: 'Check the terms and conditions box to continue.',
	conversationImportAgreementRead: 'Read the terms and conditions',
	conversationImportContinueSingle: 'Continue',
	conversationImportCreateBook: 'Create my book',
	conversationImportDropFormats: 'Full .zip recommended: do not open it (photos & media included)',
	conversationImportDropHint: 'Drop your .zip here, or',
	conversationImportFileNotSupportedError: 'Your file is not valid as an archive! Please select a valid archive (.zip)',
	conversationImportFileSummary: 'Your name is {name} and you have {count} conversations in this archive.',
	conversationImportFileTooBigError: 'Your file is too large! (more than 4GB). Please contact us to resolve this issue',
	conversationImportJsonOnlyHint: 'JSON file only: photos and media will not be included. For an illustrated book, upload the complete .zip — don\'t unzip it. If your browser already extracted the archive, compress the "messages" folder into a .zip.',
	conversationImportLuxEyebrow: 'Your story',
	conversationImportLuxPrivacy: 'Your messages stay private: only the conversation you choose is used.',
	conversationImportLuxTagline: 'A one-of-a-kind gift, from you: no one else could give this.',
	conversationImportOptionsHint: "Everything is included by default: uncheck only what you don't want.",
	conversationImportOptionsImagesDesc: 'Photos from your conversation will be printed in the book.',
	conversationImportOptionsImagesLabel: 'Photos & images',
	conversationImportOptionsMediasDesc: 'Accessible via QR codes printed in the book (10-year storage included).',
	conversationImportOptionsMediasLabel: 'Videos, audio & GIFs',
	conversationImportOptionsNoMedia: 'Your file does not contain photos or media: your book will include messages only.',
	conversationImportOptionsTitle: 'Photos & memories',
	conversationImportOptionsTransferNote: 'Transfer may take a few minutes depending on the number of photos: please stay on this page.',
	conversationImportProgressCustomize: 'Customize',
	conversationImportProgressExport: 'Export',
	conversationImportProgressUpload: 'Upload',
	conversationImportProviderNext: 'Send my conversation',
	conversationImportSelectToContinue: 'Select a conversation to continue.',
	conversationImportSelectionHintMultiple: 'Pick the conversation you want to turn into a book: use search to filter the list.',
	conversationImportSelectionListCount: '{shown} of {total} conversations',
	conversationImportSelectionNoMatch: 'No conversation matches your search.',
	conversationImportStepPickThread: 'Choose a conversation',
	conversationImportStepMedia: 'Photo options',
	conversationImportStepTerms: 'Accept terms',
	conversationImportExtrasLockedHint: 'Choose a conversation above to unlock these options.',
	conversationImportPickThreadBeforeTerms: 'You still need to choose a conversation above before continuing.',
	conversationImportChangeThread: 'Change conversation',
	conversationImportSelectionConfirmedHint: 'Perfect: you can customize your book below.',
	conversationImportSelectionHintSingle: 'One conversation found in your file.',
	conversationImportSelectionSummary: `Selected conversation: {name} (contains {count} {count, plural,
			=0 {message}
			=1 {message}
			other {messages}
		})`,
	conversationImportSelectionSummary2: 'Selected conversation: {name}',
	conversationImportSelectionText: 'Type your friend\'s name...',
	conversationImportSelectionTitle: 'Select your conversation',
	conversationImportSelectionTitleSingle: 'Your conversation',
	conversationImportStepCreation: 'Creating your book',
	conversationImportStepExtraction: 'Analyzing your file',
	conversationImportStepFinal: 'Final touches',
	conversationImportStepImages: 'Uploading photos',
	conversationImportStepMedias: 'Uploading videos & audio',
	conversationImportStepMessages: 'Saving messages',
	conversationImportSuccess: 'Congratulations! <br></br>Your conversation has been successfully imported!',
	conversationImportTransferEyebrow: 'Almost there',
	conversationImportTransferStatMedias: 'Videos & audio',
	conversationImportTransferStatMessages: 'Messages',
	conversationImportTransferStatPhotos: 'Photos',
	conversationImportTransferStay: 'Please stay on this page until the transfer is complete.',
	conversationImportResumeTitle: 'A previous transfer was interrupted.',
	conversationImportResumeTextFile: 'Re-select the same file ({name}) to resume where it stopped.',
	conversationImportResumeText: 'Re-select the same file to resume where it stopped.',
	conversationImportResumeButton: 'Resume the transfer',
	conversationImportResumeDiscard: 'Start over',
	conversationImportDuplicateTitle: 'This conversation is already on your account',
	conversationImportDuplicateEyebrow: 'Identical conversation',
	conversationImportDuplicateLead: 'We found an identical conversation. You can open the existing one to avoid a duplicate transfer.',
	conversationImportDuplicateQuestion: 'What would you like to do?',
	conversationImportDuplicateUseExisting: 'Use the existing conversation',
	conversationImportDuplicateImportAnyway: 'Import again',
	conversationImportTransferSubtitle: 'Just a moment: your story is taking shape.',
	conversationImportTransferTitle: "We're preparing your book",
	conversationImportTutorialGoNext: 'See more',
	conversationImportTutorialStep: 'Step #{step}',
	conversationImportDetailToggle: 'See the detailed guide with screenshots',
	conversationImportDetailCardTitle: 'First time?',
	conversationImportDetailCardSubtitle: 'Illustrated step-by-step guide ({count} steps with screenshots)',
	conversationImportDetailCardAction: 'Open the guide',
	conversationImportDetailTitle: 'Detailed step-by-step guide',
	conversationImportDetailStepOf: 'Step {current} of {total}',
	conversationImportDetailPrev: 'Previous',
	conversationImportDetailNext: 'Next',
	conversationImportDetailClose: 'Close',
	conversationImportUploadSuccess: 'Archive received: choose your conversation on the next step',
	conversationImportUploadSuccessSingle: 'File received: continue to personalize your book',
	conversationImportValidationWaiting: 'Validation in progress...',
	conversationInstagramImportAlert: '<b>JSON</b> format required (not HTML). Tip: exporting <b>Messages</b> only is faster, but not mandatory.',
	conversationInstagramImportCta: 'Open Instagram settings',
	conversationInstagramImportIntro: 'Export your Instagram messages in 3 steps:',
	conversationInstagramImportDemoTitle: 'Export your Instagram messages',
	conversationInstagramImportDemoExportMeta: 'Export to Device · JSON',
	conversationInstagramImportDemoDownloadsAvailable: 'Available downloads',
	conversationInstagramImportDemoStartExport: 'Start export',
	conversationInstagramImportDemoCustomizeMessages: 'Messages only',
	conversationInstagramImportDemoCustomize: 'Customize information',
	conversationInstagramImportDemoConfirmTitle: 'Confirm your export',
	conversationInstagramImportDemoSave: 'Save',
	conversationInstagramImportDemoMessagesTip: 'Optional but faster: clear all, then Messages only.',
	conversationInstagramImportDemoDataPayments: 'Payments',
	conversationInstagramImportDemoDataComments: 'Comments',
	conversationInstagramImportDemoClearAll: 'Clear all',
	conversationInstagramImportDemoActivitySection: 'Your Instagram activity',
	conversationInstagramImportDemoPickSpecific: 'Choose specific information to export',
	conversationInstagramImportDemoExportExternal: 'Export to an external service',
	conversationInstagramImportDemoExportDevice: 'Export to my device',
	conversationInstagramImportDemoChooseDestination: 'Choose where to export',
	conversationInstagramImportDemoProfileAccount: 'Your account · Instagram',
	conversationInstagramImportDemoProfileName: 'Your account name',
	conversationInstagramImportDemoAccountShort: 'Your account',
	conversationInstagramImportDemoProfiles: 'Profiles',
	conversationInstagramImportDemoChooseProfile: 'Choose a profile',
	conversationInstagramImportDemoPastActivity: 'Past activity',
	conversationInstagramImportDemoCurrentActivity: 'Current activity',
	conversationInstagramImportDemoCreateExport: 'Create export',
	conversationInstagramImportDemoExportIntro: 'Create a copy of your information to download to your device.',
	conversationInstagramImportDemoExportTitle: 'Export your information',
	conversationInstagramImportDemoCaptionStart: 'Tap Start export',
	conversationInstagramImportDemoCaptionDevice: 'Tap Export to my device',
	conversationInstagramImportDemoCaptionProfile: 'Choose your Instagram profile',
	conversationInstagramImportDemoCaptionCreate: 'Tap Create export',
	conversationInstagramImportDemoCaptionMessages: 'Tip: Clear all, then Messages only (faster)',
	conversationInstagramImportDemoCaptionJson: 'Choose JSON format, then Save',
	conversationInstagramImportDemoCaptionDrop: 'Download the .zip when ready, then add it below',
	conversationInstagramImportDemoPlatform: 'Instagram',
	conversationInstagramImportDemoDataMessages: 'Messages',
	conversationInstagramImportDemoFormat: 'Format',
	conversationInstagramImportDemoMediaQuality: 'Media quality',
	conversationInstagramImportDemoQualityLow: 'Low',
	conversationInstagramImportDemoJsonNotice: 'JSON required for your book. HTML will not work.',
	conversationInstagramImportDemoReadyHint: 'Add the complete .zip below — don\'t unzip it. You\'ll pick the chat afterwards.',
	conversationInstagramImportStep1: 'Tap <b>Create export</b>, choose your <b>Instagram</b> profile, then <b>Export to my device</b>.',
	conversationInstagramImportStep2: 'Tip for a faster export: <b>Clear all</b>, check <b>Messages</b> only. Choose <b>JSON</b> format and <b>Low</b> media quality.',
	conversationInstagramImportStep3: 'Tap <b>Start export</b>, wait for the email (10 min to 24 h), download the <b>.zip</b> and add it below — <b>don\'t unzip it</b>. You\'ll pick the chat afterwards.',
	conversationInstagramImportDetailTitle: 'Instagram export: detailed guide',
	conversationInstagramImportDetailIntro: 'Follow each step with the screenshots below. The button above opens the export page directly.',
	conversationInstagramImportDetailSkipApp: 'I used the button above — skip to step 5',
	conversationInstagramImportDetailStep1: 'Open the <b>Instagram</b> app, then go to <b>Settings</b> via the three dots at the top right.',
	conversationInstagramImportDetailStep2: 'Select <b>Accounts Center</b>.',
	conversationInstagramImportDetailStep3: 'Tap <b>Your information and permissions</b>.',
	conversationInstagramImportDetailStep4: 'Choose <b>Export your information</b>.',
	conversationInstagramImportDetailStep5: 'Go to <b>Download or transfer information</b>. If you used the button above, you are already on this page.',
	conversationInstagramImportDetailStep6: 'Select <b>Instagram</b>. This step may not appear on some accounts.',
	conversationInstagramImportDetailStep7: 'Choose <b>Some of your information</b>.',
	conversationInstagramImportDetailStep8: 'Scroll to <b>Messages</b>, check it, then tap <b>Next</b>.',
	conversationInstagramImportDetailStep9: 'Tap <b>Download to device</b>.',
	conversationInstagramImportDetailStep10: 'Choose the desired date range, <b>JSON</b> format and <b>low</b> media quality for a faster download.',
	conversationInstagramImportDetailStep11: 'Your archive will be ready within <b>10 minutes to 24 hours</b>. You will receive an email when it is available: you can also find it on the Account Center page.',
	conversationInstagramImportDetailStep12: 'Download the complete <b>.zip</b> file to your device, then add it below — <b>don\'t unzip it</b>. We\'ll only use the chat you pick next.',
	conversationKakaotalkImportIntro: 'It all starts on your phone. Are you on iPhone or Android?',
	conversationKakaotalkImportPlatformIphone: 'iPhone',
	conversationKakaotalkImportPlatformAndroid: 'Android',
	conversationKakaotalkImportIphoneStep1: 'On your iPhone, open <b>KakaoTalk</b> and the conversation you want in your book.',
	conversationKakaotalkImportIphoneStep2: 'Tap the <b>menu</b> (☰) at the top right, then the <b>settings</b> icon at the bottom of the panel.',
	conversationKakaotalkImportIphoneStep3: 'Tap <b>Export chat history</b>, then choose <b>Send text messages only</b>.',
	conversationKakaotalkImportIphoneStep4: 'Save the <b>.txt</b> file (Files, email, AirDrop), then add it below — <b>don\'t edit it</b>.',
	conversationKakaotalkImportAndroidStep1: 'On your phone, open <b>KakaoTalk</b> and the conversation you want in your book.',
	conversationKakaotalkImportAndroidStep2: 'Tap the <b>menu</b> (☰) at the top right, then the <b>settings</b> icon at the bottom of the panel.',
	conversationKakaotalkImportAndroidStep3: 'Tap <b>Export chat history</b>, then choose <b>Send text only</b>.',
	conversationKakaotalkImportAndroidStep4: 'Save the <b>.txt</b> file (Files, Google Drive, email), then add it below — <b>don\'t edit it</b>.',
	conversationKakaotalkImportAlert: 'One conversation per export. The other option also copies your photos, but KakaoTalk does not link them to the messages: choose text only, photos will appear as a simple word.',
	conversationKakaotalkImportDesktopNote: 'On a computer (Windows or Mac): open the conversation menu, then <b>Save chat</b>. The <b>.txt</b> file you get works here too.',
	conversationLineImportIntro: 'It all starts on your phone. Are you on iPhone or Android?',
	conversationLineImportPlatformIphone: 'iPhone',
	conversationLineImportPlatformAndroid: 'Android',
	conversationLineImportIphoneStep1: 'On your iPhone, open <b>LINE</b> and the conversation you want in your book.',
	conversationLineImportIphoneStep2: 'At the top of the chat, tap the <b>menu</b> (☰) → <b>Settings</b>.',
	conversationLineImportIphoneStep3: 'Tap <b>Export chat history</b>, then choose how to send the file (Files, email, AirDrop).',
	conversationLineImportIphoneStep4: 'Save the <b>.txt</b> file, then add it below — <b>don\'t edit it</b>.',
	conversationLineImportAndroidStep1: 'On your phone, open <b>LINE</b> and the conversation you want in your book.',
	conversationLineImportAndroidStep2: 'At the top of the chat, tap the <b>menu</b> (☰) → <b>Settings</b>.',
	conversationLineImportAndroidStep3: 'Tap <b>Export chat history</b>, then choose how to send the file (Files, Google Drive, email).',
	conversationLineImportAndroidStep4: 'Save the <b>.txt</b> file, then add it below — <b>don\'t edit it</b>.',
	conversationLineImportAlert: 'One conversation per export. Only the messages currently visible in the chat are saved, and LINE does not export photos or stickers as images.',
	conversationLineImportDesktopNote: 'On a computer (Windows or Mac): open <b>Chats</b>, double-click the conversation, then use the <b>menu</b> at the top → <b>Save chat</b>. This export is not available on LINE for Chrome.',
	conversationLinkedinImportIntro: 'Export your LinkedIn conversations in 3 steps:',
	conversationLinkedinImportCta: 'Open the LinkedIn export page',
	conversationLinkedinImportStep1: 'From a <b>web browser</b> (computer or phone), open the page above. Otherwise: <b>Me</b> → <b>Settings & Privacy</b> → <b>Data privacy</b> → <b>Get a copy of your data</b>.',
	conversationLinkedinImportStep2: 'Ask for an archive containing your <b>Messages</b>: tick the <b>Messages</b> file, or choose the larger archive, then click <b>Request archive</b>.',
	conversationLinkedinImportStep3: 'Download the <b>.zip</b> from the LinkedIn email (10 min to 24 h), then add it below — <b>don\'t unzip it</b>: you\'ll pick the chat afterwards.',
	conversationLinkedinImportAlert: 'This export does not exist in the LinkedIn mobile app: use a browser. The archive must contain the <b>messages.csv</b> file (LinkedIn exports neither photos nor attachments).',
	conversationLaunchButton: 'Launch in production',
	conversationMediaAudioOpusWarning: 'If you cannot read this file, use another compatible browser (like Google Chrome)',
	conversationMedias: 'Media',
	conversationMediasCount: '{count} media(s)',
	conversationMerge: 'Merge conversations',
	conversationMergeInfo: 'Select the conversations to merge, then click on the button below the list:',
	conversationMergeRequestSuccess: 'Conversations will be merged soon! You will receive an email when merge is finished.',
	conversationMergeHintEyebrow: 'Good to know',
	conversationMergeHintTitle: 'Combine into one conversation',
	conversationMergeHintSingle: 'Several chat threads? Import each conversation with +, then merge them into one conversation.',
	conversationMergeHintReady: 'You can merge your conversations into a single chronological conversation.',
	conversationMergeSelect: 'Select this conversation',
	conversationMergeUnselect: 'Deselect this conversation',
	conversationMessageAdd: 'Add a message',
	conversationMessageAttachments: 'Attachments',
	conversationMessageEdit: 'Edit message',
	conversationMessageEditSelect: 'Select this message',
	conversationMessageEditUnselect: 'Deselect this message',
	conversationMessageHiddenAlert: 'This message has been hidden and will not appear in your printed book.',
	conversationMessageHiddenLabel: 'Hide message?',
	conversationMessageInsert: 'Insert a message here',
	conversationMessageSelect: 'Select this message',
	conversationMessageSelectorDateFrom: 'Select messages after',
	conversationMessageSelectorDateTo: 'Select messages before',
	conversationMessageDateHint: 'Change the date and time to place this message where you want in the conversation.',
	conversationMessageSender: 'Sender',
	conversationMessageSenderPlaceholder: 'Choose a sender',
	conversationMessageSenderRequiredHint: 'Choose who sends this message to save it.',
	conversationMessageAnnotation: 'Annotation',
	conversationMessageAnnotationNoMedia: 'An annotation cannot include a photo, video or audio file.',
	conversationMessageText: 'Text',
	conversationMessageTextPlaceholder: 'Type your text',
	conversationMessageMediaLabel: 'Photo, video or audio',
	conversationMessageMediaDragDrop: 'Drag a photo, video or audio file here',
	conversationMessageMediaTapSelect: 'Tap to choose a photo, video or audio file',
	conversationMessageMediaOpenFinder: 'Choose a file',
	conversationMessageMediaPickSenderFirst: 'Choose a sender first to add a photo, video or audio file.',
	conversationMessageSetUnVisibleButton: 'Hide this message from the printed book',
	conversationMessageSetVisibleButton: 'Reshow message',
	conversationMessages: 'Messages',
	conversationMessagesCount: '{count} messages',
	conversationMessagesCount2: `{count, plural,
		=0 {message}
		=1 {message}
		other {messages}
	}`,
	conversationMessagesEditDisableAlert: 'If you need to personalize your messages, you need to enable it with a payment.',
	conversationMessagesEditEnableButton: 'Enable personalization',
	conversationMessagesEditEnableButton2: 'Enable personalization for {price}',
	conversationMessagesEditHideSelected: 'Hide selected messages',
	conversationMessagesEditShowSelected: 'Show selected messages',
	conversationMessagesEditTitle: 'Message customization',
	conversationMessagesEditTooManySelected: 'Too many messages selected',
	conversationMessagesImagesCount: `{count} {count, plural,
		=0 {picture}
		=1 {picture}
		other {images}
	}`,
	conversationMessagesImagesCount2: `{count, plural,
		=0 {picture}
		=1 {picture}
		other {images}
	}`,
	conversationMessagesLoadingAlert: 'Retrieving messages...',
	conversationMessagesLuxEyebrow: 'Your book',
	conversationMessagesLuxHint: 'Search, hide or edit messages. Your changes apply to your selection.',
	conversationMessagesLuxSavePreview: 'Save · back to preview',
	conversationMessagesLuxBackPreview: 'View preview',
	conversationMessagesLuxCount: '{messages, number} {messages, plural, one {message} other {messages}}, {photos, number} {photos, plural, one {photo} other {photos}} and {medias, number} {medias, plural, one {media file} other {media files}} in your selection',
	conversationMessagesFilterResults: '{count, number} {count, plural, one {result} other {results}}',
	conversationMessagesOnlyHidden: 'Hidden only',
	conversationMessagesResetFilters: 'Reset filters',
	conversationMessagesShowHidden: 'Show hidden messages',
	conversationMessagesResetChanges: 'Undo all changes',
	conversationMessagesResetChangesButton: 'Undo everything',
	conversationMessagesResetChangesConfirm: 'This will restore the conversation to its original imported state. All your changes (hidden, edited or added messages) will be permanently lost. Continue?',
	conversationMediaTypePhotos: 'Photos',
	conversationMediaTypeVideos: 'Videos',
	conversationMediaTypeAudios: 'Audios',
	conversationMediaTypeLinks: 'Links',
	conversationMediaTypeOther: 'Other',
	conversationMessagesToolSearch: 'Search',
	conversationMessagesToolMedias: 'Medias',
	conversationMessagesToolDates: 'Dates',
	conversationMessagesToolHidePeriod: 'Hide a period',
	conversationMessagesToolHidden: 'Display',
	conversationMessagesToolReset: 'Changes',
	conversationMessagesToolResetNone: 'None',
	conversationMessagesToolResetCount: '{count, number} {count, plural, one {change} other {changes}}',
	conversationMessagesHiddenViewHint: 'Choose which messages appear in the list below.',
	conversationMessagesHiddenViewAll: 'All',
	conversationMessagesHiddenViewVisible: 'Visible only',
	conversationMessagesHiddenViewHidden: 'Hidden only',
	conversationMessagesResetChangesHint: 'Restore the conversation to its original imported state. All your changes (hidden, edited or added messages) will be lost.',
	conversationMessagesToolSearchNone: 'None',
	conversationMessagesToolMediasAll: 'All messages',
	conversationMessagesToolDatesAll: 'Whole period',
	conversationMessagesToolHidePeriodNone: 'No period',
	conversationMessagesToolHiddenShown: 'Shown',
	conversationMessagesToolHiddenMasked: 'Masked',
	conversationMessagesBestofCuratedHint: 'Your Best Of has been assembled: it is already filled up to its maximum number of pages. You can hide messages, and show others back as long as the book does not get longer.',
	conversationMessagesBestofFullError: 'Your Best Of is already full. To show these messages, first hide about {pages, number} {pages, plural, one {page} other {pages}} elsewhere.',
	conversationMessagesHidePeriodHint: 'Hide (or show again) every message between two dates in one go.',
	conversationMessagesHidePeriodFrom: 'From',
	conversationMessagesHidePeriodTo: 'To',
	conversationMessagesHidePeriodCount: '{count, number} {count, plural, one {message} other {messages}} in this period ({visible} visible, {hidden} hidden)',
	conversationMessagesHidePeriodConfirmHide: 'Hide {count, number} {count, plural, one {message} other {messages}} of this period?',
	conversationMessagesHidePeriodConfirmShow: 'Show {count, number} {count, plural, one {message} other {messages}} of this period again?',
	conversationMessagesHidePeriodHide: 'Hide this period',
	conversationMessagesHidePeriodShow: 'Show this period again',
	conversationMessagesHidePeriodItem: 'Period {index}',
	conversationMessagesHidePeriodAdd: 'Add a period',
	conversationMessagesHidePeriodInvalid: 'The end date must be after the start date.',
	conversationMessagesToolHidePeriodCount: '{count, number} {count, plural, one {period} other {periods}}',
	conversationMessagesSearchPlaceholder: 'Search a word, a name…',
	conversationMessagesMediasCount: `{count} {count, plural,
		=0 {media}
		=1 {media}
		other {media}
	}`,
	conversationMessagesMediasCount2: `{count, plural,
		=0 {media}
		=1 {media}
		other {media}
	}`,
	conversationMessagesSelectAllFiltered: 'Select all ({count, number})',
	conversationMessagesSelectVisible: 'Select this page',
	conversationMessengerImportClassicAlert: 'Chat missing? Switch to <b>After 2023</b>. <b>JSON</b> format required (not HTML). Tip: exporting <b>Messages</b> only is faster, but not mandatory.',
	conversationMessengerImportClassicCta: 'Open Meta to export',
	conversationMessengerClassicImportDemoReadyHint: 'Add the complete .zip below — don\'t unzip it. You\'ll pick the chat afterwards.',
	conversationMessengerClassicImportDemoExportMeta: 'Export to Device · JSON',
	conversationMessengerClassicImportDemoDownloadsAvailable: 'Available downloads',
	conversationMessengerClassicImportDemoStartExport: 'Start export',
	conversationMessengerClassicImportDemoQualityLow: 'Low',
	conversationMessengerClassicImportDemoMediaQuality: 'Media quality',
	conversationMessengerClassicImportDemoCustomizeMessages: 'Messages only',
	conversationMessengerClassicImportDemoCustomize: 'Customize information',
	conversationMessengerClassicImportDemoConfirmTitle: 'Confirm your export',
	conversationMessengerClassicImportDemoJsonNotice: 'JSON required for your book. HTML will not work.',
	conversationMessengerClassicImportDemoFormat: 'Format',
	conversationMessengerClassicImportDemoSave: 'Save',
	conversationMessengerClassicImportDemoMessagesTip: 'Optional but faster: clear all, then Messages only.',
	conversationMessengerClassicImportDemoDataMessages: 'Messages',
	conversationMessengerClassicImportDemoDataPayments: 'Payments',
	conversationMessengerClassicImportDemoDataComments: 'Comments',
	conversationMessengerClassicImportDemoClearAll: 'Clear all',
	conversationMessengerClassicImportDemoActivitySection: 'Your Facebook activity',
	conversationMessengerClassicImportDemoPickSpecific: 'Choose specific information to export',
	conversationMessengerClassicImportDemoExportExternal: 'Export to an external service',
	conversationMessengerClassicImportDemoExportDevice: 'Export to my device',
	conversationMessengerClassicImportDemoChooseDestination: 'Choose where to export',
	conversationMessengerClassicImportDemoAccountShort: 'Your account',
	conversationMessengerClassicImportDemoProfileAccount: 'Your account · Facebook',
	conversationMessengerClassicImportDemoPlatform: 'Facebook',
	conversationMessengerClassicImportDemoProfileName: 'Your account name',
	conversationMessengerClassicImportDemoProfiles: 'Profiles',
	conversationMessengerClassicImportDemoChooseProfile: 'Choose a profile',
	conversationMessengerClassicImportDemoPastActivity: 'Past activity',
	conversationMessengerClassicImportDemoCurrentActivity: 'Current activity',
	conversationMessengerClassicImportDemoCreateExport: 'Create export',
	conversationMessengerClassicImportDemoExportIntro: 'Create a copy of your information to download to your device.',
	conversationMessengerClassicImportDemoExportTitle: 'Export your information',
	conversationMessengerClassicImportDemoCaptionDrop: 'Download the .zip when ready, then add it below',
	conversationMessengerClassicImportDemoCaptionStart: 'Tap Start export',
	conversationMessengerClassicImportDemoCaptionJson: 'Choose JSON format, then Save',
	conversationMessengerClassicImportDemoCaptionMessages: 'Tip: Clear all, then Messages only (faster)',
	conversationMessengerClassicImportDemoCaptionDevice: 'Tap Export to my device',
	conversationMessengerClassicImportDemoCaptionProfile: 'Choose your Facebook profile',
	conversationMessengerClassicImportDemoCaptionCreate: 'Tap Create export',
	conversationMessengerClassicImportDemoTitle: 'Export your Messenger chats from before 2023',
	conversationMessengerEncryptedImportDemoTitle: 'Export your Messenger chats from after 2023',
	conversationImportDemoBadgeMeta: 'Example: do this on Meta, using the button above',
	conversationMessengerEncryptedImportDemoBadge: 'Example: do this on Messenger.com, using the button above',
	conversationMessengerEncryptedImportDemoCaptionLogin: 'On a computer, open Messenger.com and sign in',
	conversationMessengerEncryptedImportDemoCaptionSettings: 'Click the settings gear at the bottom left',
	conversationMessengerEncryptedImportDemoCaptionPrivacy: 'Open Privacy and safety',
	conversationMessengerEncryptedImportDemoCaptionEncrypted: 'Choose End-to-end encrypted chats',
	conversationMessengerEncryptedImportDemoCaptionStorage: 'Open Message storage',
	conversationMessengerEncryptedImportDemoCaptionDownloadData: 'Click Download message storage data',
	conversationMessengerEncryptedImportDemoCaptionRange: 'Keep Media checked, then pick the All time range',
	conversationMessengerEncryptedImportDemoCaptionDrop: 'Click Download file, then add the .zip below',
	conversationMessengerEncryptedImportDemoLandingTitle: 'A place for interesting conversations',
	conversationMessengerEncryptedImportDemoLandingText: 'Messenger lets you stay in touch with the people you care about.',
	conversationMessengerEncryptedImportDemoContinueAs: 'Continue as Your name',
	conversationMessengerEncryptedImportDemoSwitchAccount: 'Switch account',
	conversationMessengerEncryptedImportDemoChats: 'Chats',
	conversationMessengerEncryptedImportDemoSearch: 'Search in Messenger',
	conversationMessengerEncryptedImportDemoContactName: 'Your contact',
	conversationMessengerEncryptedImportDemoContactStatus: 'Active now',
	conversationMessengerEncryptedImportDemoLockBadge: 'End-to-end encrypted',
	conversationMessengerEncryptedImportDemoMenuPreferences: 'Preferences',
	conversationMessengerEncryptedImportDemoMenuProfileName: 'Edit profile name',
	conversationMessengerEncryptedImportDemoMenuRestricted: 'Restricted accounts',
	conversationMessengerEncryptedImportDemoMenuAccessibility: 'Accessibility',
	conversationMessengerEncryptedImportDemoMenuHelp: 'Help',
	conversationMessengerEncryptedImportDemoPrivacyTitle: 'Privacy and safety',
	conversationMessengerEncryptedImportDemoPrivacyReceipts: 'Read receipts',
	conversationMessengerEncryptedImportDemoPrivacyReported: 'Reported chats',
	conversationMessengerEncryptedImportDemoPrivacyKeys: 'Verify keys in chat',
	conversationMessengerEncryptedImportDemoEncryptedTitle: 'End-to-end encrypted chats',
	conversationMessengerEncryptedImportDemoEncryptedHint: 'Manage your end-to-end encrypted chat settings',
	conversationMessengerEncryptedImportDemoEncryptedAlerts: 'Security alerts',
	conversationMessengerEncryptedImportDemoEncryptedPreviews: 'Previews',
	conversationMessengerEncryptedImportDemoStorageTitle: 'Message storage',
	conversationMessengerEncryptedImportDemoStorageHint: 'Manage how you store and access your chat history',
	conversationMessengerEncryptedImportDemoStorageIntro: 'Your end-to-end encrypted messages are stored securely in your backup.',
	conversationMessengerEncryptedImportDemoStoragePin: 'Reset PIN code',
	conversationMessengerEncryptedImportDemoStorageMethods: 'Manage security methods',
	conversationMessengerEncryptedImportDemoStorageRemember: 'Remember this browser',
	conversationMessengerEncryptedImportDemoStorageDownload: 'Download message storage data',
	conversationMessengerEncryptedImportDemoStorageDownloadHint: 'Download all your end-to-end encrypted messages and attachments.',
	conversationMessengerEncryptedImportDemoStorageAutoImport: 'Turn off automatic imports',
	conversationMessengerEncryptedImportDemoDownloadTitle: 'Download your data',
	conversationMessengerEncryptedImportDemoDownloadIntro: 'You can download a copy of all your end-to-end encrypted messages and attachments at any time.',
	conversationMessengerEncryptedImportDemoMediaTip: 'Keep Media checked, otherwise your book will have no photos.',
	conversationMessengerEncryptedImportDemoFileNotice: 'Preparing your file can take several minutes.',
	conversationMessengerEncryptedImportDemoDownloadFile: 'Download file',
	conversationMessengerEncryptedImportDemoReadyHint: 'Add the complete .zip below — don\'t unzip it. You\'ll pick the chat afterwards.',
	conversationMessengerImportClassicStep1: 'Tap <b>Create export</b>, choose your <b>Facebook</b> profile, then <b>Export to my device</b>.',
	conversationMessengerImportClassicStep2: 'Tip for a faster export: <b>Clear all</b>, check <b>Messages</b> only. Choose <b>JSON</b> format and <b>Low</b> media quality.',
	conversationMessengerImportClassicStep3: 'Tap <b>Start export</b>, wait for the email (10 min to 24 h), download the <b>.zip</b> and add it below — <b>don\'t unzip it</b>. You\'ll pick the chat afterwards.',
	conversationMessengerImportContext: 'A chat that started before 2023 can continue after encryption was turned on. Messenger then splits it into two archives. Import both, then merge them from your conversation list.',
	conversationMessengerImportEncryptedAlert: 'Keep <b>Media</b> checked, otherwise your book will have no photos. Chat missing? Switch to <b>Before 2023</b>.',
	conversationMessengerImportClassicDetailTitle: 'Before 2023 export: detailed guide',
	conversationMessengerImportClassicDetailIntro: 'Follow each step with the screenshots below. The button above opens the export page directly.',
	conversationMessengerImportClassicDetailSkipApp: 'I used the button above — skip to step 5',
	conversationMessengerImportClassicDetailStep1: 'Open the <b>Messenger</b> app, then go to <b>Settings</b> via the three dots.',
	conversationMessengerImportClassicDetailStep2: 'Tap the <b>gear icon</b>.',
	conversationMessengerImportClassicDetailStep3: 'Select <b>Accounts Center</b>.',
	conversationMessengerImportClassicDetailStep4: 'Tap <b>Your information and permissions</b>.',
	conversationMessengerImportClassicDetailStep5: 'Choose <b>Download your information</b>.',
	conversationMessengerImportClassicDetailStep6: 'Go to <b>Download or transfer information</b>. If you used the button above, you are already on this page.',
	conversationMessengerImportClassicDetailStep7: 'Select <b>Facebook</b>. This step may not appear on some accounts.',
	conversationMessengerImportClassicDetailStep8: 'Choose <b>Some of your information</b>.',
	conversationMessengerImportClassicDetailStep9: 'Check <b>Messages</b> only, then tap <b>Next</b>.',
	conversationMessengerImportClassicDetailStep10: 'Tap <b>Download to device</b>.',
	conversationMessengerImportClassicDetailStep11: 'Choose the desired date range, <b>JSON</b> format and <b>low</b> quality. Your archive will be ready within <b>10 minutes to 24 hours</b>: you will receive an email.',
	conversationMessengerImportClassicDetailStep12: 'Download the complete <b>.zip</b> file to your device, then add it below — <b>don\'t unzip it</b>. We\'ll only use the chat you pick next.',
	conversationMessengerImportEncryptedDetailTitle: 'After 2023 export: detailed guide',
	conversationMessengerImportEncryptedDetailIntro: 'Follow each step with the screenshots below. You can also use the button above to open Messenger.com and skip to step 2.',
	conversationMessengerImportEncryptedDetailSkipApp: 'I\'m already on Messenger.com — skip to step 2',
	conversationMessengerImportEncryptedDetailStep1: 'On a computer, open <b>Messenger.com</b> and click your profile photo at the bottom left.',
	conversationMessengerImportEncryptedDetailStep2: 'Click <b>Privacy &amp; safety</b>.',
	conversationMessengerImportEncryptedDetailStep3: 'Click <b>End-to-end encrypted chats</b>.',
	conversationMessengerImportEncryptedDetailStep4: 'Click <b>Secure storage</b>.',
	conversationMessengerImportEncryptedDetailStep5: 'Click <b>Download data from secure storage</b>.',
	conversationMessengerImportEncryptedDetailStep6: 'Click <b>Download file</b>.',
	conversationMessengerImportEncryptedDetailStep7: 'Enter your Facebook password, then click <b>Confirm</b>.',
	conversationMessengerImportEncryptedDetailStep8: 'Click <b>Download</b>. Preparing your file may take a few minutes.',
	conversationMessengerImportEncryptedDetailStep9: 'Download the complete <b>.zip</b> file to your computer, then add it below — <b>don\'t unzip it</b>. We\'ll only use the chat you pick next.',
	conversationMessengerImportEncryptedCta: 'Open Messenger.com to export',
	conversationMessengerImportEncryptedStep1: 'On a computer, open <b>Messenger.com</b>, sign in, then click the <b>settings gear</b> in the bottom left.',
	conversationMessengerImportEncryptedStep2: 'Go to <b>Privacy and safety</b>, then <b>End-to-end encrypted chats</b>, then <b>Message storage</b>.',
	conversationMessengerImportEncryptedStep3: 'Click <b>Download message storage data</b>. Keep <b>Media</b> checked and choose the <b>All time</b> range.',
	conversationMessengerImportEncryptedStep4: 'Click <b>Download file</b>, then add the <b>.zip</b> below — <b>don\'t unzip it</b>: you\'ll pick the chat afterwards.',
	conversationMessengerImportIntro: 'Start with <b>After 2023</b>: encrypted chats, on Messenger.com. Switch to <b>Before 2023</b> if yours is not there.',
	conversationMessengerImportPlatformClassic: 'Before 2023',
	conversationMessengerImportPlatformEncrypted: 'After 2023',
	conversationMessengerImportMissingTip: 'Chat not listed? Go back and try the <b>After 2023</b> export.',
	conversationMessengerImportEmptyTitle: 'No conversation found in this archive',
	conversationNoData: "You haven't created a conversation yet!",
	conversationNoMessages: 'No messages',
	conversationOnlyMedias: 'Show only media',
	conversationOptionWithImagesHelp1: 'Currently, your books will be WITH your images or photos',
	conversationOptionWithImagesHelp2: 'Currently, your books will be WITHOUT your images or photos',
	conversationOptionWithImagesHelp3: 'Depending on the number of photos this may slow down the transfer of the conversation, please stay on this page while loading, it may take up to 10min. If you still encounter difficulties, send us your archive via www.fromsmash.com to the address hello@monlivresms.com with the name of the contact or group, we will find a solution for you.',
	conversationOptionWithImagesLabel: 'Include images of the conversation?',
	conversationOptionWithMediaHelp: 'QR codes in your book let you watch the videos, audio and GIFs again. Media storage is free for 10 years.',
	conversationOptionWithMediasLabel: 'Include videos/audios/gifs of the conversation?',
	conversationOrder: 'Order',
	conversationOrderButton: 'Order now',
	conversationOrderButtonEbook: 'Get my PDF',
	conversationOrderButtonEbookWithPrice: 'Get my PDF · {price}',
	conversationOrderButtonWithPrice: 'Order now · {price}',
	conversationOrderButtonWithPriceVolumes: 'Order my {count} books · {price}',
	conversationOrderDiscountLabel: '-{discount}% off this conversation when ordering {threshold} copies and more',
	conversationOrderQuantity: 'Number of copies',
	conversationOrderSummary2: `Your order has {bookCount} {bookCount, plural,
				=0 {book}
				=1 {book}
				other {books}
			} & {pdfCount} {pdfCount, plural,
				=0 {eBook}
				=1 {eBook}
				other {eBooks}
			} {freeCount, plural,
				=0 {}
				=1 {+1 free eBook}
				other {+{freeCount} Free eBooks}
			} for {pdfTotal}`,
	conversationOrderSummaryBestof: '1 Best Of book · {bestofTotal}',
	conversationOrderSummaryBook: `{bookCount} {bookCount, plural,
          =1 {volume}
          other {volumes}
      } · {bookTotal} {discount, plural,
          =0 {}
          other {: {discount}% off included}
      }`,
	conversationOrderSummaryPdf: '1 complete eBook · {pdfTotal}',
	conversationOrderTotal: 'Total',
	conversationOrders: 'Orders',
	conversationParticipantColorHelp: 'Click here to change the bubble color',
	conversationParticipantColorBlushClair: 'Light blush',
	conversationParticipantColorCielClair: 'Light sky',
	conversationParticipantColorLavandeClaire: 'Light lavender',
	conversationParticipantColorPruneClaire: 'Light plum',
	conversationParticipantColorPecheClaire: 'Light peach',
	conversationParticipantColorSaugeClair: 'Light sage',
	conversationParticipantColorMiel: 'Honey',
	conversationParticipantColorPerle: 'Pearl',
	conversationParticipantNameHelp: 'Click here to change the participant name',
	conversationParticipantNameError: 'Name is too long (max: {max} chars)',
	conversationParticipantPositionHelp: 'Click to switch participant position (on the right or left)',
	conversationParticipantPositionLeft: 'Left',
	conversationParticipantPositionRight: 'Right',
	conversationParticipants: 'Participants',
	conversationParticipantsEditTitle: 'Participants',
	conversationParticipantsLuxEyebrow: 'Your conversation',
	conversationParticipantsLuxHint: 'Edit names, bubble colors and left/right position for each participant.',
	conversationParticipantsLuxSavePreview: 'Save · back to preview',
	conversationParticipantsLuxSaved: 'Saved',
	conversationParticipantsSameSideHint: 'Several participants are on the same side. Check left/right positions.',
	conversationPauseButton: 'Pause my order',
	conversationPauseConfirmText: 'The generation of your books will be paused. You can resume it at any time.',
	conversationPreviewBestofHelpButton: 'How does the selection work?',
	conversationPreviewBestofHelpText: 'Our formula looks at every moment of your conversation: how dense the exchanges are, whether it\'s a real back-and-forth or a monologue, and how rich the content is (photos, text, emojis). The first and last messages are always kept. Only the moments that really counted make it into the book. Your messages stay private: we never read what they say, only the shape of the exchange.',
	conversationPreviewBestofHint: 'Illustrative Best Of preview: the selection of your best messages happens after ordering, when the PDF is generated.',
	conversationPreviewBestofHintDismiss: 'Dismiss',
	conversationPreviewBestofHintLearnMore: 'Learn more',
	conversationPreviewBestofPriceNote: 'Selection after ordering',
	conversationPreviewTypeBestofTaglineCompare: 'A lighter alternative: your best moments in 1 volume.',
	conversationPreviewBestofLearnMore: 'How does Best-Of selection work?',
	conversationPreviewBookCaption: 'Turn the pages to discover your book.',
	conversationPreviewBookNumber: `{index}{index, plural,
			  =0 {}
			  =1 {er}
			  =2 {nd}
			  other {th}
		  } book`,
	conversationPreviewBookSelection: 'Selection of books',
	conversationPreviewBooksSelectAllBooks: 'Select all paper books',
	conversationPreviewBooksSelectAllEBooks: 'Select all ebooks',
	conversationPreviewBooksUnselectAll: 'Deselect all',
	conversationPreviewBrowserWarning: 'Your browser may slow things down. For the best experience, we recommend Google Chrome.',
	conversationPreviewCardLabelCover: 'Cover',
	conversationPreviewCardLabelDates: 'Dates',
	conversationPreviewCardLabelMessages: 'Messages',
	conversationPreviewZoneDone: 'Already explored',
	conversationPreviewZoneHintCover: 'Colour, photo, title, preface',
	conversationPreviewZoneHintParticipants: 'Names and bubble colours',
	conversationPreviewZoneHintDates: 'Period covered by the book',
	conversationPreviewZoneHintMessages: 'Hide or edit messages',
	conversationPreviewCardLabelParticipants: 'Participants',
	conversationPreviewCoverEditButton: 'Edit cover',
	conversationPreviewCoverOpenLabel: 'Open the book',
	conversationPreviewCustomizeClose: 'Close customisation',
	conversationPreviewCustomizeDone: 'Finish customisation',
	conversationPreviewCustomizeEyebrow: 'Make it yours',
	conversationPreviewCustomizeHint: 'Tap a card to edit.',
	conversationPreviewCardsHintTitle: 'Names, dates, messages',
	conversationPreviewCardsHintText: 'Here you change the names, the period and the messages.',
	conversationPreviewCustomizeTopics: 'Cover · names · dates · messages',
	conversationPreviewCustomizeTitle: 'Customize my book',
	conversationPreviewDemoBadge: 'MonLivreSMS',
	conversationPreviewEditionBelowHint: 'Choose your edition below',
	conversationPreviewEditionEyebrow: 'Your edition',
	conversationPreviewEditionHint: 'Compare options and pick the one that fits you.',
	conversationPreviewPausedEyebrow: 'Order on hold',
	conversationPreviewPausedTitle: 'Happy with your changes?',
	conversationPreviewPausedHint: 'Your order is on hold. Edit your book, then confirm to resume production.',
	conversationPreviewPausedScrollHint: 'Save my changes',
	conversationPreviewMissingMediasBanner: 'Some media (photos, files) from your conversation are missing or could not be retrieved. Please check your messages before confirming.',
	conversationPreviewMissingMediasCta: 'Add missing media',
	bookMissingPhotoLabel: 'Photo unavailable',
	conversationMissingMediasBadge: 'Missing media',
	conversationMissingMediasCta: 'Add missing media',
	conversationResumeWithoutMediasButton: 'Continue without these photos',
	conversationResumeMissingMediasConfirmText: 'Some photos are still missing. Your book will go to print without them. Add the photos if you can.',
	orderMissingMediasAlert: 'Some photos are missing from a conversation in this order. Complete them so production can resume.',
	missingMediasRecoveryTitle: 'Missing media ({count})',
	missingMediasRecoveryIntro: '{count, plural, one {# photo is missing} other {# photos are missing}} from your book. You can re-upload your export or fix each item below.',
	missingMediasRecoveryFirstDate: 'First missing media: {date}.',
	missingMediasRecoveryArchiveTitle: 'Complete with a new export',
	missingMediasRecoveryRecommended: 'Recommended',
	missingMediasRecoveryArchiveHelp: 'Upload your {provider} export again (zip). Only missing photos will be added: your messages and edits stay unchanged.',
	missingMediasRecoveryArchiveCta: 'Drop your export file',
	missingMediasRecoveryArchiveWorking: 'Looking for missing photos in your file…',
	missingMediasRecoveryArchiveError: 'Could not read this file. Make sure it is your messaging app export.',
	missingMediasRecoveryNoMatch: 'No file matching the missing media was found.',
	missingMediasRecoveryListTitle: 'Fix media one by one',
	missingMediasRecoveryRescan: 'Check again',
	missingMediasRecoveryEmpty: 'No missing media detected right now.',
	missingMediasRecoveryAddPhoto: 'Add a photo',
	missingMediasRecoveryIgnore: 'Ignore',
	missingMediasRecoveryContact: 'Contact us',
	missingMediasRecoveryResolved: 'All missing media have been handled. Your book is going back to production.',
	missingMediasRecoverySuccessEyebrow: 'All set',
	missingMediasRecoverySuccessTitle: 'Great, your photos are complete',
	missingMediasRecoverySuccessText: 'All missing media have been handled. Your book is going back to production.',
	missingMediasRecoverySuccessCta: 'Back to my preview',
	conversationMissingMediasFixedSuccess: 'Great: all missing media are complete. Your book is going back to production.',
	conversationMissingMediasFixedHint: 'Nothing left to do on your side: production resumes automatically.',
	missingMediasRecoveryError: 'Something went wrong. Please try again or contact us.',
	missingMediasRecoverySmsTitle: 'SMS / iPhone transfer',
	missingMediasRecoverySmsStepIcloud: 'On iPhone: open the conversation in Messages, tap the contact, scroll down and download iCloud photos.',
	missingMediasRecoverySmsStepBackup: 'Make a new unencrypted local backup (Mac/PC), then run our software again to resend this conversation\'s media.',
	missingMediasRecoverySmsStepAndroid: 'On Android: reopen the MonLivreSMS app and resend the conversation.',
	conversationPreviewEditionMetaLabel: 'Edition details',
	conversationPreviewEditionScrollLabel: 'Go to edition section',
	conversationPreviewEditionTitle: 'Choose your edition',
	conversationPreviewEndBody: 'The rest of your messages is waiting. Order to see your book in full.',
	conversationPreviewEndBodyPaused: 'Confirm your changes. The digital version arrives by email right after, so you can look it over.',
	conversationPreviewEndCta: 'Order now',
	conversationPreviewEndCtaPaused: 'Save my changes',
	conversationPreviewEndTitle: 'The rest is waiting',
	conversationPreviewFormatSelection: 'Format selection',
	conversationPreviewHelpTourButton: 'Show page help',
	conversationPreviewHeroHeading: 'Book preview',
	conversationPreviewHeroTitle: 'Your words, bound forever.',
	conversationPreviewMetaBestofPages: '~400 pages',
	conversationPreviewMetaBestofSelection: 'Smart selection',
	conversationPreviewMetaEbook: 'Free eBook',
	conversationPreviewMetaMessages: '{count} messages',
	conversationPreviewMetaPages: '{pages} pages',
	conversationPreviewMetaPdfInstant: 'Instant PDF',
	conversationPreviewMetaPdfCredit: 'Credit toward the book',
	conversationPreviewPdfPriceNote: 'Deducted if you upgrade to print',
	conversationPreviewPdfLearnMore: 'How does it work?',
	conversationPreviewPdfHelpText: 'You pay {ebookPrice} and get your PDF. If you later order the printed book at {bookPrice}, these {ebookPrice} come off: {remainingPrice} left. The credit stays on your account.',
	conversationPreviewReassurancePdfCredit: 'These {price} are deducted if you upgrade to the book',
	conversationPreviewStickyPdfCredit: '{price} credit if you upgrade to the book',
	conversationPreviewEbookCreditBanner: 'You have {amount} credit on this conversation. It will be deducted automatically when you order the printed book.',
	conversationPreviewEbookCreditOrderHint: '{credit} credit deducted · catalogue price {fullPrice}',
	conversationPreviewStickyEbookCredit: '{credit} credit applied',
	paymentMethodEbookCreditHint: 'Ebook credit toward your printed book',
	cartTotalsEbookCredit: 'Ebook credit',
	cartTotalsCredit: 'Credit',
	conversationPreviewMetaVolume: '{count} volume',
	conversationPreviewMetaVolumes: '{count} volumes',
	conversationPreviewPagesDivideEquallyLabel: 'Split the pages equally between the books?',
	conversationPreviewPagesSetMaxBookPagesLabel: 'Would you like books of {max} pages preferably?',
	conversationPreviewPrefaceEditButton: 'Edit preface',
	conversationPreviewPrefaceEmptyButton: 'Write my preface',
	conversationPreviewPrefaceEmptyText: 'A few words to open your book. You can skip this and come back later.',
	conversationPreviewPrefaceEmptyTitle: 'Your preface (optional)',
	conversationPreviewPrefaceOptionalBadge: 'Optional',
	conversationPreviewPricePerVolume: '{price}/volume',
	conversationPreviewCollectionPriceNote: '{count} volumes · {price}/volume',
	conversationPreviewCollectionUntilLabel: 'Which volumes',
	conversationPreviewCollectionUntilAll: 'From the first volume to the last',
	conversationPreviewCollectionUntilOpen: 'Choose',
	conversationPreviewCollectionUntilClose: 'Close',
	conversationPreviewCollectionUntilPartial: '{count, plural, one {The first volume} other {The first {count} volumes}}',
	conversationPreviewCollectionUntilSuffix: '{count, plural, one {The last volume} other {The last {count} volumes}}',
	conversationPreviewCollectionUntilSingle: 'Volume {number}',
	conversationPreviewCollectionUntilWindow: 'Volumes {from} to {to}',
	conversationPreviewCollectionUntilPeriod: 'From {start} to {end}',
	conversationPreviewCollectionUntilHint: 'The other volumes stay in the conversation, ready for another order.',
	conversationPreviewCollectionUntilAriaStart: 'First volume to print',
	conversationPreviewCollectionUntilAriaEnd: 'Last volume to print',
	conversationPreviewTypeBookTaglinePartial: '{count, plural, one {The first volume of your conversation.} other {The first {count} volumes of your conversation.}}',
	conversationPreviewTypeBookTaglineSuffix: '{count, plural, one {The last volume of your conversation.} other {The last {count} volumes of your conversation.}}',
	conversationPreviewTypeBookTaglineWindowSingle: 'Volume {number} of your conversation.',
	conversationPreviewTypeBookTaglineWindow: 'Volumes {from} to {to} of your conversation.',
	conversationPreviewStickyCollectionVolumes: 'Collection · {count} volumes',
	conversationPreviewReassuranceShipping: 'Free delivery worldwide',
	conversationPreviewExpressDeliveryLead: 'Express delivery {where} from',
	conversationPreviewExpressDeliveryDate: '{date}',
	conversationPreviewSocialProofAria: 'Rated {rating} out of 5 on Trustpilot, based on more than {count} reviews',
	conversationPreviewSocialProofCount: '{count}+ reviews',
	conversationPreviewSubtitle: 'Personalize cover, names, dates and messages before choosing your edition.',
	conversationPreviewTitle: 'Your story, in print.',
	conversationPreviewTypeBestofDescription: '400 pages, your best exchanges. Free eBook included.',
	conversationPreviewTypeBestofTitle: 'Best Of',
	conversationPreviewTypeBookDescription: '{count} volume · Full story. Free eBook included.',
	conversationPreviewTypeBookDescriptionWithPrice: '{count} volumes · {unitBreakdown} · Complete collection. Free eBook included.',
	conversationPreviewTypeBookMessagesHint: ' · {count} messages',
	conversationPreviewTypeBookPagesHint: ' · {pages} pages',
	conversationPreviewTypeBookTaglineMulti: 'Your full conversation in {count} printed books.',
	conversationPreviewTypeBookTaglineSingle: 'Your full story, page by page.',
	conversationPreviewTypeBookTitle: 'Full Collection',
	conversationPreviewTypeHighlight: 'Recommended',
	conversationPreviewTypePdfDescription: 'Keep your conversation as a PDF. This amount counts toward the book, if you want it later.',
	conversationPreviewTypePdfTitle: 'Digital',
	conversationPreviewTypeSelectionTitle: 'Choose your format',
	conversationPrinterMode: 'Printer mode',
	conversationProgress: 'Progress',
	conversationProviderButton: 'Access settings',
	conversationProviderType: 'Provider',
	conversationRemoveButton: 'Delete conversation',
	conversationRemoveConfirmText: 'If you delete this conversation, its media will be removed and cannot be recovered.',
	conversationRemoveConfirmTitle: 'Remove conversation',
	conversationRemoveFlagConfirmMessage: 'Do you want to remove this flag from the conversation?',
	conversationRemoveSuccess: 'Conversation removed!',
	conversationRestartProcess: 'Restart',
	conversationResumeButton: 'Confirm and print',
	conversationResumeConfirmText: 'Your conversation will be marked as verified and will be generated to be printed.',
	conversationValidateModificationsButton: 'Save my changes',
	conversationValidateModificationsConfirmTitle: 'Save your changes?',
	conversationValidateModificationsConfirmBook: 'Your book will go back into production with your changes.',
	conversationValidateModificationsConfirmEbook: 'Your eBook will be regenerated with your changes and sent to you again by email.',
	conversationValidateModificationsConfirmMissingMedias: 'Some media from your conversation are missing. Please check them before confirming: your book will go into production with your current changes.',
	conversationValidateModificationsSuccessBook: 'Your changes have been saved. Your book is going back into production.',
	conversationValidateModificationsSuccessEbook: 'Your changes have been saved. Your regenerated eBook will be sent to you by email.',
	conversationValidateModificationsBackToList: 'Back to my conversations',
	conversationSelectThread: 'Select a discussion',
	conversationShareCancelButton: 'Not now',
	conversationShareConfirmButton: 'See my highlights',
	conversationShareConfirmText: 'Your conversation holds some striking stats. We turned them into images, ready to share.',
	conversationShareConfirmTitle: 'Look what we found...',
	conversationSmsImportAndroidAlert: 'No file to drop here. Stay on the transfer screen in the app so all photos are included.',
	conversationSmsImportAndroidCta: 'Download Android app',
	conversationSmsImportAndroidStep1: "On your Android phone, download our <b>off-store app</b> below: SMS access isn't allowed on Google Play.",
	conversationSmsImportAndroidStep2: 'Open the downloaded file. If Android won\'t allow the install, tap <b>Settings</b>, turn on <b>Allow from this source</b>, then go back.',
	conversationSmsImportAndroidStep3: 'If <b>Play Protect</b> appears, tap <b>More details</b>, then <b>Install anyway</b>. Then tap <b>Install</b>, and <b>Open</b>.',
	conversationSmsImportAndroidStep4: 'In the app, allow access to <b>SMS</b> and <b>contacts</b>.',
	conversationSmsImportAndroidStep5: 'Choose the <b>conversation</b> and confirm. Stay on screen until the transfer finishes: the messages go straight to your account.',
	conversationSmsImportContext: 'Our Android app is <b>not on Google Play</b>: SMS access is restricted there. Android and Play Protect ask you to confirm before the app opens.',
	conversationSmsImportFooter: 'Once the transfer is done, customise your book on this site: the app will redirect you automatically.',
	conversationSmsImportAndroidDetailIntro: 'Follow each step on your Android phone. The app is <b>not on Google Play</b>. Android, then Play Protect, ask you to confirm before it opens. That\'s expected.',
	conversationSmsImportAndroidDetailSkipApp: 'I already downloaded the app: skip to step 2',
	conversationSmsImportAndroidDetailStep1: 'Download our SMS export app outside Google Play (button below): SMS access is not allowed on the Play Store.',
	conversationSmsImportAndroidDetailStep2: 'After downloading, tap <b>Open</b>.',
	conversationSmsImportAndroidDetailStep3: 'Tap <b>Settings</b> to allow installation.',
	conversationSmsImportAndroidDetailStep4: 'Turn on <b>Allow from this source</b>, then go back to the install screen.',
	conversationSmsImportAndroidDetailStep5: 'If <b>Play Protect</b> appears, tap <b>More details</b>, then <b>Install anyway</b>. Install, open the app, and allow access to SMS and contacts.',
	conversationSmsImportAndroidDetailStep6: 'Select the <b>conversation</b> you want.',
	conversationSmsImportAndroidDetailStep7: 'Confirm and validate: stay on the transfer screen until finished so all photos are included. You will be redirected automatically to customise your book.',
	conversationSmsImportAndroidDetailTitle: 'Android SMS export: detailed guide',
	conversationSmsImportMacDetailIntro: 'Download the software and follow the on-screen instructions. The screenshots below are mainly there to help with installation.',
	conversationSmsImportMacDetailSkipSoftware: 'I already downloaded the software — skip to step 8',
	conversationSmsImportMacDetailStep1: 'Plug your iPhone into your Mac with a USB cable.',
	conversationSmsImportMacDetailStep10: 'Open <b>System Settings</b> → <b>Privacy & Security</b>.',
	conversationSmsImportMacDetailStep11: 'Scroll to the bottom and click <b>Open Anyway</b>.',
	conversationSmsImportMacDetailStep12: 'On the security prompt, click <b>Allow</b>.',
	conversationSmsImportMacDetailStep13: 'Click <b>Open</b>.',
	conversationSmsImportMacDetailStep14: 'Click <b>Continue</b>.',
	conversationSmsImportMacDetailStep15: 'Click <b>Continue</b> again.',
	conversationSmsImportMacDetailStep16: 'Click <b>Install</b>.',
	conversationSmsImportMacDetailStep17: 'On the security prompt, click <b>Allow</b> again.',
	conversationSmsImportMacDetailStep18: 'Click <b>Close</b> to exit the installer.',
	conversationSmsImportMacDetailStep19: 'Open <b>Finder</b> → <b>Applications</b>, then launch <b>MonLivreSMS</b>.',
	conversationSmsImportMacDetailStep2: 'For photos in your book: open the <b>Messages</b> app, select the conversation, then tap the <b>contact name</b>.',
	conversationSmsImportMacDetailStep20: 'Click the <b>Apple menu</b> top left → <b>System Settings</b>.',
	conversationSmsImportMacDetailStep21: 'Open <b>Privacy & Security</b> → <b>Full Disk Access</b>.',
	conversationSmsImportMacDetailStep22: 'Drag the MonLivreSMS icon into the list (click and hold), then check <b>Full Disk Access</b>.',
	conversationSmsImportMacDetailStep23: 'Click <b>Open</b> to confirm.',
	conversationSmsImportMacDetailStep24: 'Click <b>Open</b> again if a second confirmation appears.',
	conversationSmsImportMacDetailStep25: 'Choose the <b>conversation</b> to export: texts and photos will be sent to your account. Stay on the transfer screen until finished, with a stable internet connection.',
	conversationSmsImportMacDetailStep3: 'Scroll to the very bottom of the contact card.',
	conversationSmsImportMacDetailStep4: 'Tap <b>Download</b> to import all iCloud photos onto your iPhone.',
	conversationSmsImportMacDetailStep5: 'Open <b>Finder</b>, select your iPhone in the sidebar, uncheck <b>Encrypt local backup</b> and enable <b>Back up all data on this Mac</b>.',
	conversationSmsImportMacDetailStep6: 'Click <b>Back Up Now</b> and wait for the backup to finish.',
	conversationSmsImportMacDetailStep7: 'Download the MonLivreSMS Mac software (button below on this page).',
	conversationSmsImportMacDetailStep8: 'Double-click the downloaded <b>MonLivreSMS</b> folder.',
	conversationSmsImportMacDetailStep9: 'Click <b>OK</b> to start the installer.',
	conversationSmsImportMacDetailTitle: 'iPhone + Mac SMS export: detailed guide',
	conversationSmsImportPcDetailIntro: 'Download the software and follow the on-screen instructions. The screenshots below are mainly there to help with installation.',
	conversationSmsImportPcDetailSkipSoftware: 'I already downloaded the software — skip to step 3',
	conversationSmsImportPcDetailStep1: 'Plug your iPhone into your PC with a USB cable.',
	conversationSmsImportPcDetailStep2: 'Download the MonLivreSMS PC software (button below on this page).',
	conversationSmsImportPcDetailStep3: 'Install <link>iTunes</link> if you do not have it yet.',
	conversationSmsImportPcDetailStep4: 'Launch iTunes.',
	conversationSmsImportPcDetailStep5: 'Sign in with your <b>Apple ID</b> and approve on your iPhone if prompted.',
	conversationSmsImportPcDetailStep6: 'Once your iPhone is recognised, click <b>Continue</b>.',
	conversationSmsImportPcDetailStep7: 'Under <b>Summary</b>, uncheck <b>Encrypt local backup</b> then click <b>Back Up Now</b> (to this computer, not iCloud).',
	conversationSmsImportPcDetailStep8: 'When the backup is done, open the MonLivreSMS folder. If Windows shows a warning, click <b>More info</b> then <b>Run anyway</b>. Then pick the conversation to send to your account.',
	conversationSmsImportPcDetailTitle: 'iPhone + PC SMS export: detailed guide',
	conversationSmsImportHelpToggle: 'Need more detailed help?',
	conversationSmsImportIntro: 'No file to upload here. Everything runs through our software (iPhone) or app (Android). Pick your setup:',
	conversationSmsImportMacAlert: 'No file upload on this page: transfer starts from the software, which guides you on screen.',
	conversationSmsImportMacCta: 'Download Mac software',
	conversationSmsImportMacHelp: 'If the software cannot find your backup: System Settings → Privacy & Security → <b>Full Disk Access</b> → add MonLivreSMS (unlock the padlock bottom left first).',
	conversationSmsImportMacStep1: 'Download the Mac software.',
	conversationSmsImportMacStep2: 'Install it and <b>follow the on-screen instructions</b>.',
	conversationSmsImportMacStep3: 'Choose the <b>conversation</b> to send to your account, then stay on screen until the transfer finishes.',
	conversationSmsImportMacStep4: 'Install the software below, grant <b>Full Disk Access</b> in System Settings → Privacy, then pick the conversation to send to your account.',
	conversationSmsImportPcAlert: 'No file upload on this page: transfer starts from the software, which guides you on screen.',
	conversationSmsImportPcCta: 'Download PC software',
	conversationSmsImportPcHelp: 'In iTunes, make sure <b>Encrypt local backup</b> is unchecked before clicking <b>Back Up Now</b>. Visual guide above.',
	conversationSmsImportPcStep1: 'Download the PC software.',
	conversationSmsImportPcStep2: 'Install it and <b>follow the on-screen instructions</b>.',
	conversationSmsImportPcStep3: 'Choose the <b>conversation</b> to send to your account, then stay on screen until the transfer finishes.',
	conversationSmsImportPcStep4: 'Install the software below, run it (allow if Windows warns you), then pick the conversation to send to your account.',
	conversationSmsImportPlatformAndroid: 'Android',
	conversationSmsImportPlatformIphoneMac: 'iPhone + Mac',
	conversationSmsImportPlatformIphonePc: 'iPhone + PC',
	conversationSmsImportTagline: 'No file to upload here: everything happens in our software or app.',
	conversationSnapchatImportAlert: 'Full <b>.zip</b> archive required: do not open it. Your messages will be printed in the book (Snapchat exports do not include printable photos).',
	conversationSnapchatPlaceholderMedia: '[Media]',
	conversationSnapchatPlaceholderNote: '[Voice note]',
	conversationSnapchatPlaceholderSticker: '[Sticker]',
	conversationSnapchatPlaceholderSnap: '[Snap]',
	conversationSnapchatPlaceholderAudio: '[Audio]',
	conversationSnapchatStatusParticipantAdded: 'A member was added to the group',
	conversationSnapchatStatusNameChanged: 'The group name changed',
	conversationSnapchatStatusConversationCreated: 'Conversation created',
	conversationSnapchatStatusGeneric: 'Snapchat notification',
	conversationSnapchatImportPartialContent: '{withText} messages with text out of {total}. Snapchat does not export the body of unsaved messages.',
	conversationSnapchatImportCta: 'Open Snapchat My Data',
	conversationSnapchatImportIntro: 'Export your Snapchat conversations in 3 steps:',
	conversationSnapchatImportStep1: 'In the app: tap your avatar → settings (gear icon) → <b>Privacy</b> → <b>My Data</b>. You can also use the link above.',
	conversationSnapchatImportStep2: 'Log in if asked, then tap <b>Submit a Request</b> at the bottom: Snapchat will email you when your archive is ready (a few hours to 1 day).',
	conversationSnapchatImportStep3: 'Download the <b>.zip</b> from the email, then add it below — <b>don\'t unzip it</b>: you\'ll pick the chat afterwards.',
	conversationSnapchatImportDetailTitle: 'Snapchat export: detailed guide',
	conversationSnapchatImportDetailIntro: 'Follow each step with the screenshots below. You can also use the button above to open My Data directly and skip to step 4.',
	conversationSnapchatImportDetailSkipApp: 'I used the button above — skip to step 4',
	conversationSnapchatImportDetailStep1: 'Open <b>Snapchat</b> and tap your profile picture.',
	conversationSnapchatImportDetailStep2: 'Tap the <b>gear icon</b> to open settings.',
	conversationSnapchatImportDetailStep3: 'Scroll down to <b>Account Actions</b>, then tap <b>My Data</b>. You can also use the button above.',
	conversationSnapchatImportDetailStep4: 'Check <b>Chat History</b>, choose <b>JSON</b> and <b>HTML</b> formats, then tap <b>Next</b>.',
	conversationSnapchatImportDetailStep5: 'Choose the desired date range, confirm your email address, then tap <b>Submit</b>.',
	conversationSnapchatImportDetailStep6: 'Snapchat will email you when the export is ready: this can take a few hours to several days.',
	conversationSnapchatImportDetailStep7: 'When you receive the email, click the link to access your data.',
	conversationSnapchatImportDetailStep8: 'On Snapchat, tap <b>View Export</b>, then <b>Download</b>.',
	conversationSnapchatImportDetailStep9: 'Download the complete <b>.zip</b> file to your device, then add it below — <b>don\'t unzip it</b>. We\'ll only use the chat you pick next.',
	conversationStatusConfigured: 'Awaiting generation',
	conversationStatusDone: 'Completed',
	conversationStatusOngeneration: 'Being generated',
	conversationStatusOnproduction: 'In production',
	conversationStatusOnvalidation: 'Waiting to print',
	conversationStatusPending: 'Waiting',
	conversationTelegramImportAlert: 'One conversation at a time. Include <b>media</b> in the export for an illustrated book: upload the complete <b>.zip</b> as is.',
	conversationTelegramImportDetailTitle: 'Telegram export: detailed guide',
	conversationTelegramImportDetailIntro: 'Follow each step with the screenshots below. Use the button above to download Telegram Desktop, or skip to step 2 if it is already installed.',
	conversationTelegramImportDetailSkipApp: 'I already have Telegram Desktop — skip to step 2',
	conversationTelegramImportDetailStep1: 'On PC, <b>Telegram Desktop</b> is the right app. On Mac, download <b>Telegram Desktop</b> from the link above: the App Store app named Telegram cannot export a chat. On the App Store, the right app is called <b>Telegram Lite</b>.',
	conversationTelegramImportDetailStep2: 'Open the <b>conversation</b> you want to turn into a book.',
	conversationTelegramImportDetailStep3: 'Click the <b>three dots</b> at the top right, then <b>Export chat history</b>.',
	conversationTelegramImportDetailStep4: 'Check <b>all file types</b> (photos, videos, voice messages, etc.), set the max file size to <b>1500 MB</b> and choose <b>JSON</b>. If there is no format choice, an HTML export works too.',
	conversationTelegramImportDetailStep5: 'Click <b>Export</b> at the bottom right to start the export.',
	conversationTelegramImportDetailStep6: 'On your phone, tap <b>Allow</b> if prompted. Compress the exported folder into a <b>.zip</b>, then add it below — <b>don\'t unzip it</b>: you\'ll confirm your options afterwards.',
	conversationTelegramImportCta: 'Download Telegram Desktop',
	conversationTelegramImportIntro: 'Export a Telegram chat in 4 steps:',
	conversationTelegramImportStep1: 'On PC, install <b>Telegram Desktop</b>. On Mac, skip the App Store app named Telegram: download <b>Telegram Desktop</b> from the link above (on the App Store it is called Telegram Lite). Then open the conversation you want to turn into a book.',
	conversationTelegramImportStep2: 'Click the <b>three dots</b> at the top right → <b>Export chat history</b>.',
	conversationTelegramImportStep3: 'Check <b>photos, videos and files</b>, choose <b>JSON</b> (HTML is accepted too), then click <b>Export</b> and wait for the download to finish.',
	conversationTelegramImportStep4: 'Compress the exported folder into a <b>.zip</b> (right-click → compress), then add it below — <b>don\'t unzip it</b>: you\'ll confirm your options afterwards.',
	conversationTextSearch: 'Search message text',
	conversationTypeAndroidDownloadAlt: 'Or copy/paste the link into your favorite browser',
	conversationTypeAndroidDownloadButton: 'Download the application',
	conversationTypeAndroidIntroText1: 'To print your SMS Book with an Android phone, it is necessary to use your smartphone (Samsung, HTC, Huawei, for example).',
	conversationTypeAndroidIntroText2: 'Install the My SMS Book application on your Android mobile phone by clicking on the following link: (application not available on GooglePlay)',
	conversationTypeAndroidIntroText3: 'Choose the co-author of your keepsake SMS book, and the start and end dates of your story.',
	conversationTypeAndroidIntroText4: 'Choose the names of the heroes of your story, write its summary and personalize your cover',
	conversationTypeAndroidIntroText5: 'To complete your SMS book, create an account and finalize your purchase using our secure payment server!',
	conversationTypeInstagramFileText1: 'Instagram will send you an email to download the archive',
	conversationTypeInstagramFileText2: 'Download it to your device',
	conversationTypeInstagramFileText3: "Click the button below, then pick the .zip in your files — don't unzip it. Example name: *yourname*_*today's date*.zip (only the chat you select is sent to print)",
	conversationTypeInstagramProviderText1: 'Recover a copy of your Instagram data by accessing the general settings of your account',
	conversationTypeInstagramProviderText2: 'Enter your email address associated with your Instagram account and choose the JSON format',
	conversationTypeInstagramProviderText3: 'Then enter your password, and click on <strong>Request a download</strong> to trigger the generation of your backup on Instagram.',
	conversationTypeIosIntroText1: 'Plug your iPhone into your COMPUTER and make an unencrypted iTunes backup. (check "This computer", UNCHECK "Encrypt iPhone backup" and click on "Back up now")',
	conversationTypeIosIntroText2: 'Download the My Book SMS software by clicking on the link corresponding to the operating system of your computer:',
	conversationTypeIosIntroText3: '<strong>WARNING, if the software does not detect a backup:</strong><br></br> - For MAC:<br></br>go to system preferences > Privacy & Security > Full Disk Access and add the application MyBookSMS by unlocking the padlock at the bottom left.<br></br> - For PC: <br></br>For your Apple security, prevents your backup from being read without your authorization.',
	conversationTypeMessengerFileText1: 'Facebook will send you an email to download the archive',
	conversationTypeMessengerFileText2: 'Download it to your device',
	conversationTypeMessengerFileText3: 'Click on the button below, then select the archive in your files leaving it in .zip example: facebook-*yourname*.zip (only the selected conversation will be sent to our printing services)',
	conversationTypeMessengerProviderText1: 'Recover a copy of your Facebook data by accessing the general settings of your account',
	conversationTypeMessengerProviderText2: 'Click on Download your information',
	conversationTypeMessengerProviderText3: `Then, set the following options:<br></br>
			  <strong>Period</strong>: (the one of your choice)<br></br>
			  <strong>Format</strong>: JSON<br></br>
			  <strong>Photo quality</strong>: Low (this is sufficient and takes less time during transfers)<br></br>
			  <strong>Your information</strong>: Messages (deselect the others)`,
	conversationTypeMessengerProviderText4: 'Warning: Please select the data format in JSON (not HTML)!',
	'conversationTypeSnapchatProviderText1.1': 'Open the Snapchat app on your device.',
	'conversationTypeSnapchatProviderText1.2': 'Click on your avatar (or Bitmoji) at the top left of the screen to access your profile.',
	'conversationTypeSnapchatProviderText1.3': 'Click the gear icon at the top right to open Settings.',
	'conversationTypeSnapchatProviderText2.1': 'Scroll down to the “Privacy” section.',
	'conversationTypeSnapchatProviderText2.2': 'Select “My Data”.',
	'conversationTypeSnapchatProviderText3.1': 'You may be asked to log in to verify your identity.',
	'conversationTypeSnapchatProviderText4.1': 'On the "My Data" page you will find a list of data you can download, including your messages.',
	'conversationTypeSnapchatProviderText4.2': 'Click on “Send a Request” at the bottom of the page.',
	'conversationTypeSnapchatProviderText5.1': 'Once your request is sent, Snapchat will process your data upload request.',
	'conversationTypeSnapchatProviderText5.2': 'This may take some time, usually a few hours to a day.',
	'conversationTypeSnapchatProviderText5.3': 'You will receive an email from Snapchat with a link to download your data when your archive is ready.',
	'conversationTypeSnapchatProviderText6.1': 'Click the link in the email to go to the download page.',
	'conversationTypeSnapchatProviderText6.2': 'Download the ZIP file containing your data.',
	'conversationTypeSnapchatProviderText7.1': 'Once the ZIP file is downloaded, do not open it.',
	'conversationTypeSnapchatProviderText7.2': 'Drop the complete ZIP file, as is, in the designated section.',
	'conversationTypeSnapchatProviderText7.3': 'You can choose the conversation of your choice to create your book.',
	conversationTypeSnapchatProviderTitle1: '1. Access Snapchat Settings:',
	conversationTypeSnapchatProviderTitle2: '2. Data Request:',
	conversationTypeSnapchatProviderTitle3: '3. Authentication:',
	conversationTypeSnapchatProviderTitle4: '4. Downloading your Data:',
	conversationTypeSnapchatProviderTitle5: '5. Waiting for Email:',
	conversationTypeSnapchatProviderTitle6: '6. Downloading Archive:',
	conversationTypeSnapchatProviderTitle7: '7. Extraction and Use of Data for MonLivreSMS:',
	'conversationTypeTelegramProviderText1.1': 'Install the Telegram application for computer on your PC or Mac from https://desktop.telegram.org/.',
	'conversationTypeTelegramProviderText1.2': 'Open the Telegram application on your computer.',
	'conversationTypeTelegramProviderText2.1': "In the app, open the conversation you want to turn into a book by clicking on your chat partner's name.",
	'conversationTypeTelegramProviderText3.1': 'Click on the three dots in the upper right corner of the conversation.',
	'conversationTypeTelegramProviderText3.2': 'Choose “Export chat history”.',
	'conversationTypeTelegramProviderText4.1': 'In the settings window, select all desired file types (images, videos, voice messages, etc.).',
	'conversationTypeTelegramProviderText4.2': 'Adjust the maximum file size for export, if necessary.',
	'conversationTypeTelegramProviderText4.3': 'Click “Export” at the bottom of the window.',
	'conversationTypeTelegramProviderText5.1': 'Locate the exported data and compress it into a ZIP file (right-click > Send to > Compressed (zipped) folder).',
	'conversationTypeTelegramProviderText6.1': 'Download the complete ZIP file',
	conversationTypeTelegramProviderTitle1: '1. Installation of the Telegram Application for Computer:',
	conversationTypeTelegramProviderTitle2: '2. Selection of the Conversation:',
	conversationTypeTelegramProviderTitle3: '3. Export of the History of the Conversation:',
	conversationTypeTelegramProviderTitle4: '4. Export Settings of the Conversation:',
	conversationTypeTelegramProviderTitle5: '5. Compression to ZIP File:',
	conversationTypeTelegramProviderTitle6: '6. Upload to MonLivreSMS:',
	conversationTypeTitle: 'Create a book from {name}',
	conversationTypeWhatsappFileText1: 'Recover your WhatsApp conversation',
	conversationTypeWhatsappFileText2: 'Choose "Attach a file"',
	conversationTypeWhatsappFileText3: 'Download the conversation',
	conversationTypeWhatsappFileText4: 'If it is not in "zip" format, compress it',
	conversationTypeWhatsappFileText5: 'If you only want the text content of your conversation, just drop the .txt file',
	conversationTypeWhatsappProviderText1: 'Export a copy of your WhatsApp conversation',
	conversationTypeWhatsappProviderText2: '<strong>From Android:</strong><br></br>Open WhatsApp<br></br>Open your chat<br></br>Tap Options',
	conversationTypeWhatsappProviderText3: '<strong>From iPhone:</strong><br></br>Open WhatsApp<br></br>Open your chat<br></br>Tap the contact name or group name<br></br>Scroll down and tap Export Chat',
	conversationVerify: 'Force verification',
	conversationViewButton: 'See the conversation',
	conversationWhatsappImportAlert: 'One conversation per export. Prefer <b>Attach Media</b> for an illustrated book. Stay on this page until the transfer finishes.',
	conversationWhatsappImportAlertAndroid: 'One conversation per export. Prefer <b>Include media</b>. On some phones only email works: use <b>Without media</b> then. Stay on this page until transfer ends.',
	conversationWhatsappImportIphoneDetailTitle: 'WhatsApp export on iPhone: detailed guide',
	conversationWhatsappImportIphoneDetailIntro: 'Follow each step on your iPhone with the screenshots below, then transfer the file to your computer or phone before dropping it here.',
	conversationWhatsappImportIphoneDetailStep1: 'Open <b>WhatsApp</b> and the conversation you want to turn into a book.',
	conversationWhatsappImportIphoneDetailStep2: 'Tap the <b>contact or group name</b> at the top of the screen.',
	conversationWhatsappImportIphoneDetailStep3: 'Scroll to the very bottom of the page until you see <b>Export Chat</b>.',
	conversationWhatsappImportIphoneDetailStep4: 'Tap <b>Export Chat</b>.',
	conversationWhatsappImportIphoneDetailStep5: 'Choose <b>Attach Media</b> for an illustrated book, or <b>Without Media</b> for messages only.',
	conversationWhatsappImportIphoneDetailStep6: 'Save the file to your computer or phone (e.g. in Files), then add it below — <b>don\'t unzip it</b>.',
	conversationWhatsappImportAndroidDetailTitle: 'WhatsApp export on Android: detailed guide',
	conversationWhatsappImportAndroidDetailIntro: 'Follow each step on your Android with the screenshots below, then transfer the file to your computer or phone before dropping it here.',
	conversationWhatsappImportAndroidDetailStep1: 'Open <b>WhatsApp</b> and the conversation you want to turn into a book.',
	conversationWhatsappImportAndroidDetailStep2: 'Tap <b>⋮</b> (top right) → <b>More</b> → <b>Export chat</b>.',
	conversationWhatsappImportAndroidDetailStep3: 'Choose <b>Include media</b> for photos, or <b>Without media</b> for messages only.',
	conversationWhatsappImportAndroidDetailStep4: 'Save the file (Files, Google Drive or email), transfer it to your computer or phone, then add it below — <b>don\'t unzip it</b>.',
	conversationWhatsappImportAndroidStep1: 'Open the chat, tap <b>⋮</b> → <b>More</b> → <b>Export chat</b>.',
	conversationWhatsappImportAndroidStep2: 'Choose <b>Include media</b> for photos in the book (or <b>Without media</b> for text only).',
	conversationWhatsappImportAndroidStep3: 'Save or share the file, then add the <b>.zip</b> below — <b>don\'t unzip it</b>.',
	conversationWhatsappImportAndroidStep4: 'Save the file (Files, Google Drive or email), transfer it to your computer or phone, then add it below — <b>don\'t unzip it</b>.',
	conversationImportDetectedPlatform: 'These steps are for {platform}. The other options stay available.',
	conversationWhatsappImportIntro: 'It all starts on your phone. Are you on iPhone or Android?',
	conversationWhatsappImportIphoneStep1: 'Open the conversation, tap the <b>name at the top</b>, then <b>Export Chat</b>.',
	conversationWhatsappImportIphoneStep2: 'Choose <b>Attach Media</b> for photos in the book (or <b>Without Media</b> for text only).',
	conversationWhatsappImportIphoneStep3: 'Save to <b>Files</b>, then add the <b>.zip</b> below — <b>don\'t unzip it</b>.',
	conversationWhatsappImportIphoneStep4: '<b>Attach Media</b> for photos in the book, <b>Without Media</b> for messages only: save the file to your computer or phone, then add it below — <b>don\'t unzip it</b>.',
	conversationWhatsappImportPlatformAndroid: 'Android',
	conversationWhatsappImportPlatformIphone: 'iPhone',
	conversationWhatsappImportDemoTitle: 'Export your WhatsApp conversation',
	conversationWhatsappImportDemoIndividual: 'Individual chat',
	conversationWhatsappImportDemoGroup: 'Group chat',
	conversationWhatsappImportDemoCaptionOpen: 'Open the chat in WhatsApp',
	conversationWhatsappImportDemoCaptionTapName: 'Tap the name at the top',
	conversationWhatsappImportDemoCaptionExport: 'Scroll down, then tap Export Chat',
	conversationWhatsappImportDemoCaptionMedia: 'Choose Attach Media for photos in your book',
	conversationWhatsappImportDemoCaptionSave: 'Save to Files, then add it below',
	conversationWhatsappImportDemoExportLabel: 'Export Chat',
	conversationWhatsappImportDemoMediaNotice: 'Attach Media creates a larger archive, ideal for an illustrated book.',
	conversationWhatsappImportDemoAttachMedia: 'Attach Media',
	conversationWhatsappImportDemoWithoutMedia: 'Without Media',
	conversationWhatsappImportDemoSaveFiles: 'Save to Files',
	conversationWhatsappImportDemoA11y: 'Animated guide: open the chat, tap the name, export the chat, choose Attach Media, then save to Files.',
	conversationWhatsappImportDemoCaptionExportGroup: 'Open the ⋯ menu, then tap Export Chat',
	conversationWhatsappImportDemoContactName: 'Léa',
	conversationWhatsappImportDemoContactMom: 'Mom',
	conversationWhatsappImportDemoGroupName: 'Weekend trip',
	conversationWhatsappImportDemoGroupWork: 'Work: design',
	conversationWhatsappImportDemoChats: 'Chats',
	conversationWhatsappImportDemoHeaderSubContact: 'tap here for contact info',
	conversationWhatsappImportDemoHeaderSubGroup: 'tap here for group info',
	conversationWhatsappImportDemoGroupsInCommon: 'Groups in common',
	conversationWhatsappImportDemoSeeAll: 'See all ›',
	conversationWhatsappImportDemoAddFavorite: 'Add to Favorites',
	conversationWhatsappImportDemoAddList: 'Add to a list',
	conversationWhatsappImportDemoClearChat: 'Clear chat',
	conversationWhatsappImportDemoBlock: 'Block',
	conversationWhatsappImportDemoParticipants: '{count} participants',
	conversationWhatsappImportDemoAudio: 'Audio',
	conversationWhatsappImportDemoVideo: 'Video',
	conversationWhatsappImportDemoAdd: 'Add',
	conversationWhatsappImportDemoSearch: 'Search',
	conversationWhatsappImportDemoMemberYou: 'You',
	conversationWhatsappImportDemoMemberAlex: 'Alex',
	conversationWhatsappImportDemoMemberCamille: 'Camille',
	conversationWhatsappImportDemoEditGroup: 'Edit group info',
	conversationWhatsappImportDemoEditDescription: 'Edit description',
	conversationWhatsappImportAndroidDemoIncludeMedia: 'Include media',
	conversationWhatsappImportAndroidDemoWithoutMedia: 'Without media',
	conversationWhatsappImportAndroidDemoMediaNotice: 'Include media for an illustrated book. Without media is lighter.',
	conversationWhatsappImportAndroidDemoClear: 'Clear chat',
	conversationWhatsappImportAndroidDemoExport: 'Export chat',
	conversationWhatsappImportAndroidDemoReport: 'Report',
	conversationWhatsappImportAndroidDemoMore: 'More',
	conversationWhatsappImportAndroidDemoWallpaper: 'Wallpaper',
	conversationWhatsappImportAndroidDemoMute: 'Mute notifications',
	conversationWhatsappImportAndroidDemoOnline: 'online',
	conversationWhatsappImportAndroidDemoCaptionSave: 'Save or share the file, then add it below',
	conversationWhatsappImportAndroidDemoCaptionMedia: 'Choose Include media for photos in your book',
	conversationWhatsappImportAndroidDemoCaptionExport: 'Tap More, then Export chat',
	conversationWhatsappImportAndroidDemoCaptionMenu: 'Tap the menu at the top right',
	conversationWhatsappImportAndroidDemoCaptionOpen: 'Open the chat in WhatsApp',
	conversationWhatsappImportAndroidDemoTitle: 'Export your WhatsApp conversation on Android',
	conversationWhatsappImportAndroidDemoShareHint: 'Then add the .zip below — don\'t unzip it.',
	conversationWhatsappImportAndroidDemoFiles: 'Files',
	conversationWhatsappImportAndroidDemoShareVia: 'Send to…',
	conversations: 'Conversations',
	conversationsLuxEyebrow: 'Your stories',
	conversationsLuxHint: 'Pick a conversation and turn it into a book you\'ll keep.',
	ordersLuxEyebrow: 'The studio',
	ordersLuxHint: 'Follow your books from the studio to your door.',
	ordersLuxDetailTitle: 'Your book',
	ordersLuxDetailHint: 'Follow your book from the studio to your door.',
	ordersLuxViewFollow: 'Follow my book',
	ordersLuxEmptyTitle: 'Your first story is waiting for you.',
	ordersLuxEmptyHint: 'Turn a conversation into a book you\'ll want to open again and again.',
	ordersLuxStepReceived: 'Received',
	ordersLuxStepAtelier: 'Studio',
	ordersLuxStepPrint: 'Printing',
	ordersLuxStepShipped: 'On the way',
	ordersLuxStepHome: 'With you',
	ordersLuxStoryPendingpayment: 'Complete payment and we\'ll start making your book.',
	ordersLuxStoryPending: 'We\'ve got your order. The studio is already at work.',
	ordersLuxStoryOnpreparation: 'Your book is taking shape. Each page is prepared with care.',
	ordersLuxStoryOnfabrication: 'Your book is being printed. It will leave the studio soon.',
	ordersLuxStoryShipped: 'Your book is on its way to you.',
	ordersLuxStoryComplete: 'Your book is here. All that\'s left is to pick it up.',
	ordersLuxStoryCanceled: 'This order was cancelled. Your memories remain safe with us.',
	userProfileLuxEyebrow: 'Your space',
	userProfileLuxHint: 'Manage your details, sign-in methods and preferences.',
	userProfileValueEmpty: 'Not set',
	userProfileNotLinked: 'Not linked',
	userProfileNewsletterOn: 'You already receive our news and offers.',
	userProfilePasswordOn: 'Set',
	addressesLuxEyebrow: 'Your space',
	addressesLuxHint: 'Find your delivery and billing addresses.',
	addressesLuxEditHint: 'This address can be used for delivery or billing.',
	conversationsMy: 'My conversations',
	conversationsNewApp: 'New conversations on the application',
	conversationsOldApp: 'Old conversations on the application',
	copiedToClipboard: 'Copied!',
	country: 'Country',
	dashboardTitle: 'Dashboard',
	date: 'Date',
	dateActivated: 'Date of activation',
	dateCreated: 'Date of creation',
	dateLastCguAccept: 'Date of last validation of the CGU',
	dateLastEdit: 'Date of last modification',
	dateLastLogin: 'Date of last connection',
	dateSelect: 'Select a date',
	dateSelectPlaceholder: 'Click to select a date..',
	dateStatus: 'Status date',
	dateValidation: 'Validation date',
	dates: 'Dates',
	days: 'Day(s)',
	daysCount: '{count} day(s)',
	delete: 'Delete',
	deleteRequestError: 'Deletion error!',
	deleteRequestSuccess: 'Deleted!',
	description: 'Description',
	detailsInformation: 'Details',
	domain: 'Domain',
	download: 'Download',
	edit: 'Edit',
	editViewAdvanced: 'Advanced editing',
	editViewSimplified: 'Easy editing',
	elementNoItems: 'No item',
	elementsCount: `{count} {count, plural,
			  =0 {element}
			  =1 {element}
			  other {elements}
		  }`,
	example: 'Example',
	examples: 'Examples',
	file: 'File',
	fileDeleteError: 'Can\\',
	fileDeleteSuccess: 'File deleted!',
	fileSelected: 'Selected file: {file}',
	fileSwitch: 'Change file',
	fileUploadError: 'Can\\',
	fileUploadProcessStartOnSave: 'File loading will start when saved.',
	fileUploadRestrictionTypeError: 'File format not allowed! Only {types} accepted!',
	fileUploadSuccess: 'File uploaded!',
	files: 'Files',
	filtersTitle: 'Filters',
	finish: 'Finish',
	flags: 'Flags',
	free: 'Free',
	generalInformation: 'General Information',
	help: 'Help',
	hours: 'Hours',
	hoursCount: '{count} hour(s)',
	identifier: 'Identifier',
	imageDeleteError: 'Can\\',
	imageDeleteSuccess: 'Image deleted!',
	imageUploadError: 'Can\\',
	imageUploadRestrictionSize: 'Image must be {format} maximum',
	imageUploadRestrictionType: 'Image must be in {types}',
	imageUploadRestrictionTypeError: 'Image format not allowed! Only {types} accepted',
	import: 'Import',
	importModelDownloadButton: 'Download template',
	importRequestError: 'Error on import!',
	importRequestSomeFailAlert: 'Some data may be not imported!',
	importRequestSuccess: 'Data imported!',
	importerFileButton: 'Import data',
	importerFileHelp: 'You can generate a CSV file using your spreadsheet editing software (Excel, OpenOffice, ...)',
	importerFileInfo: 'Select a CSV (Comma Separated Values) file',
	importerNoItemsAlert: 'No element to import',
	importerTitle: 'Data import',
	information: 'Information',
	informationsDetails: 'Details',
	informationsGeneral: 'General information',
	invoicePrint: 'Print the invoice',
	invoicesPrint: 'Print invoices',
	isActive: 'Is active?',
	isPublic: 'Is public?',
	isUnlimited: 'Unlimited?',
	label: 'Title',
	language: 'Language',
	languageAR: 'Arabic',
	languageBN: 'Bengali',
	languageDE: 'German',
	languageEN: 'English',
	languageES: 'Spanish',
	languageFR: 'French',
	languageHI: 'Hindi',
	languageIT: 'Italian',
	languageJA: 'Japanese',
	languagePT: 'Portuguese',
	languageRU: 'Russian',
	languageZH: 'Chinese',
	learnMoreButton: 'Learn more',
	limitLabel: 'Limit type',
	limitTextForm1: 'must have a',
	listTitle: 'List',
	loadMore: 'Load more…',
	loading: 'Loading...',
	logo: 'Logo',
	minutes: 'Minute(s)',
	name: 'Name',
	next: 'Next',
	no: 'No',
	of: 'of',
	options: 'Options',
	order: 'Order',
	orderAdd: 'Add an order',
	orderAddTitle: 'Add an order',
	orderAddressPrivacyInfo: 'Your address will not be public! Only other participants in this order can view this address.',
	orderAddressShippingValid: 'Confirm delivery address',
	orderAdminListHint: 'Track and process orders by status. Use filters to narrow by country, product or validation date.',
	orderBilling: 'Billing',
	orderConfirmationGuestTitle: 'Stay informed',
	orderConfirmationHomeCta: 'Back to home',
	orderConfirmationNextStepsTitle: 'What happens next?',
	orderConfirmationOrderNumber: 'Order #{code}',
	orderConfirmationPaymentError: 'An error has occurred.... Please contact us!',
	orderConfirmationPaymentWaiting: 'Please wait... We are finalizing your payment to validate your order',
	orderConfirmationPaymentWaitingHint: 'This usually takes just a few seconds.',
	orderConfirmationPendingText: 'Your order is awaiting payment to be complete! Please click on the link below to finalize your order by confirming payment.',
	orderConfirmationPendingText2: 'PLEASE NOTE: If you pay by credit card, a payment validation time may be necessary, please wait a few moments for verifications.',
	orderConfirmationPendingTitle: 'Order awaiting payment!',
	orderConfirmationSocialText: 'Follow us on your favorite social network to stay informed of the latest news, new products and even some discounts...',
	orderConfirmationSocialTitle: 'Stay in touch!',
	orderConfirmationStepEmail: 'Email confirmation',
	orderConfirmationStepEmailDesc: 'A summary has been sent to {email}',
	orderConfirmationStepEmailDescNoEmail: 'A summary will be sent by email',
	orderConfirmationStepPreparation: 'Preparing your book',
	orderConfirmationStepPreparationDesc: 'We print and assemble your book with care',
	orderConfirmationStepShipping: 'Shipping',
	orderConfirmationStepShippingDesc: 'You will receive an email as soon as your parcel ships',
	orderConfirmationSummaryTitle: 'Your order',
	orderConfirmationText: 'Your order has been recorded and will be prepared. You will receive an email to inform you of its shipment.',
	orderConfirmationTitle: 'Well received!',
	orderConfirmationViewOrderCta: 'Track my order',
	orderContent: 'Order contents',
	orderDetails: 'Details',
	orderFlags: 'Flags',
	orderId: 'Identifier',
	orderInfoCommentAlertTitle: 'Important message',
	orderInvoice: 'Invoice',
	orderInvoicePrintButton: 'Print invoice',
	orderItemsEmpty: 'There are no items in your order',
	orderItemViewBook: 'View my book',
	orderItemsTotal: 'Total items:',
	orderMassExportInvoiceDetails: 'Export invoice details',
	orderMassSendEmail: 'Send email',
	orderMassStatusConfirmMessage: 'Update the status of {count} order(s)?',
	orderMassUpdateStatus: 'Update status',
	orderNoItems: 'You have not ordered yet!',
	orderNote: 'Note',
	orderNoteAdmin: 'Internal note (admin)',
	orderNoteAdminAdd: 'Add a note',
	orderNoteAdminEmpty: 'No internal notes for this order.',
	orderNoteAdminPlaceholder: 'Internal note visible to the team only (shipping, support…)',
	orderNoteCustomer: 'Customer rating',
	orderPaymentChooseMethodLabel: 'Choose a payment method',
	orderPaymentFinishTitle: 'Complete your payment',
	orderPaymentMethod: 'Payment method',
	orderPaymentValidButton: 'Confirm payment',
	orderPayments: 'Payments',
	orderProcessInvitationText: 'Invite your friends to fill out the box',
	orderProcessInvitationTextBefore1: 'Directos.eu is a group purchasing service between individuals, it allows you to purchase products directly from the manufacturers. in order to save you money, both on the price of the products AND on delivery costs!',
	orderProcessInvitationTextBefore2: "Don't worry! We have a solution:",
	orderProductAdd: 'Add a product',
	orderPublicAccess: 'Public access',
	orderRefunds: 'Refunds',
	orderSendStatusNotificationEmail: 'Send notification email',
	orderShipping: 'Delivery',
	orderShippingAdd: 'Add shipping',
	orderShippingFee: 'Shipping costs',
	orderShippingRemoveConfirmMessage: 'Are you sure you want to remove this shipping from the order?',
	orderShippingTrackingTitle: 'Track your order',
	orderShippingTrackingButton: 'Track my parcel',
	orderShippingTrackingHint: 'Tracking details can take a few hours to appear with the carrier.',
	orderShippings: 'Shipments',
	orderStatus: 'Status',
	orderStatusCanceled: 'Canceled',
	orderStatusComplete: 'Completed',
	orderStatusOnpreparation: 'In preparation',
	orderStatusOnprogress: 'In progress',
	orderStatusPending: 'Waiting',
	orderStatusPendingpayment: 'Waiting for payment',
	orderStatusShipped: 'Shipped',
	orderSubtotalDiscount: 'Discount',
	orderSubtotalExclTax: 'Subtotal excluding tax',
	orderSubtotalInclTax: 'Subtotal including tax',
	orderTax: 'VAT',
	orderThanks: 'Thank you for your order',
	attributionPaidLine: 'Payment received',
	attributionSkip: 'See my order',
	attributionSourceTitle: 'What made you want this book?',
	attributionSourceLead: 'Your order is already in. One answer tells us what drew you to it.',
	attributionSearchTitle: 'Before you searched, did you already know MonLivreSMS?',
	attributionSearchLead: 'A name you\'d come across before, or something new.',
	attributionOccasionTitle: 'What\'s the occasion for this book?',
	attributionOccasionLead: 'The one you have in mind.',
	attributionOtherPlaceholder: 'A few words, if you want',
	attributionOtherContinue: 'Continue',
	attributionSaveError: 'We couldn\'t save that answer. Please try again.',
	attributionOpt_bouche_a_oreille: 'Someone close told me',
	attributionOpt_vu_objet: 'I saw the book at someone\'s place',
	attributionOpt_receveur_devenu_client: 'I was given one, now it\'s my turn',
	attributionOpt_recherche: 'I was searching on Google',
	attributionOpt_instagram: 'Instagram',
	attributionOpt_tiktok: 'TikTok',
	attributionOpt_facebook: 'Facebook',
	attributionOpt_pinterest: 'Pinterest',
	attributionOpt_qvema: 'Qui veut être mon associé',
	attributionOpt_medias: 'An article, a show, or a podcast',
	attributionOpt_client_existant: 'I\'d already ordered here',
	attributionOpt_autre: 'Something else',
	attributionOpt_decouverte_pure: 'Mostly by chance',
	attributionOpt_pre_bao: 'Someone close had told me',
	attributionOpt_pre_tv: 'I\'d seen it on TV',
	attributionOpt_pre_social: 'I\'d seen it on social media',
	attributionOpt_pre_inconnu: 'I can\'t quite remember',
	attributionOpt_anniv_couple: 'The anniversary of when we met',
	attributionOpt_noel: 'Christmas',
	attributionOpt_saint_valentin: 'Valentine\'s Day',
	attributionOpt_anniversaire: 'A birthday',
	attributionOpt_deuil: 'The messages of someone I\'ve lost',
	attributionOpt_naissance: 'A birth',
	attributionOpt_distance: 'Someone leaving, or living far away',
	attributionOpt_pour_soi: 'For me, not as a gift',
	attributionOpt_autre_occasion: 'Another moment',
	bookIntentTitle: 'This book is for...',
	bookIntentLead: 'One answer, then we start.',
	bookIntentSkip: 'Skip',
	bookIntentOpt_anniv_couple: 'The anniversary of when we met',
	bookIntentOpt_anniversaire: 'Someone\'s birthday',
	bookIntentOpt_noel: 'Christmas',
	bookIntentOpt_saint_valentin: 'Valentine\'s Day',
	bookIntentOpt_souvenir: 'Someone who is no longer here',
	bookIntentOpt_plus_tard: 'Later',
	bookIntentOpt_autre: 'Something else',
	bookIntentDate_anniv_couple: 'What\'s the date?',
	bookIntentDateLead_anniv_couple: 'The day you met, or the day you celebrate together.',
	bookIntentDate_anniversaire: 'What day is their birthday?',
	bookIntentDateLead_anniversaire: 'The birthday of the person you\'re giving it to.',
	bookIntentDate_plus_tard: 'Around which date?',
	bookIntentDateLead_plus_tard: 'The day you have in mind.',
	bookIntentDateDefer: 'I\'ll add the date later',
	bookIntentDateBack: 'Back',
	bookIntentDateContinue: 'Continue',
	bookIntentSaveError: 'We couldn\'t save that answer. Please try again.',
	inboxPromptTitle: 'For your book',
	inboxPromptSignup: 'We just sent you an email, "{subject}". It\'s the start of your book, not an ad. {provider} sometimes sets it aside. Mark it as "{mark}". That small step gets the rest to you properly, with what you need to make it really well.',
	inboxPromptTransfer: 'We just sent you an email, "{subject}". It\'s the link to your conversation, not an ad. {provider} sometimes sets it aside. Mark it as "{mark}". That small step puts everything at hand, so you can make the book you want.',
	inboxPromptMarkGmail: 'Not spam',
	inboxPromptMarkYahoo: 'Not spam',
	inboxPromptButton: 'I\'ll confirm in {provider}',
	inboxPromptClose: 'Close',
	inboxPromptConfirm: 'We just sent you an email, "{subject}". It opens your account. {provider} sometimes sets it aside. Mark it as "{mark}". That small step gets the rest to you.',
	emailConfirmPageTitle: 'Confirm your address',
	emailConfirmTitle: 'Check your email',
	emailConfirmLead: 'We just sent you an email to open your account. The button inside confirms your address.',
	emailConfirmResend: 'Send the email again',
	emailConfirmResent: 'The email is on its way again.',
	emailConfirmExpired: 'This link has expired. Ask for a new one from your account.',
	emailConfirmInvalid: 'This link doesn\'t match an account.',
	emailConfirmWorking: 'Opening your account…',
	orderTotal: 'Total',
	orderTotalTTC: 'Total including tax',
	orderTotalTax: 'VAT {rate}%',
	orderTotalToPay: 'Total amount to pay: {total}€',
	orderTotals: 'Totals',
	orderUserRegisterAlert: 'We need your email so we can reach you if there is an issue with your order.',
	orderView: 'View order',
	orderViewShort: 'Order',
	orderWeight: 'Weight',
	orderitemAddProductTitle: 'Edit item data',
	orders: 'Orders',
	ordersContactTitle: 'Contact by orders',
	ordersEditSuccess: 'Orders updated!',
	ordersMy: 'My orders',
	ordersMyViewButton: 'View my orders',
	packingInformation: 'Packaging information',
	parcelGroupInfo: 'Group package by package number',
	parcelGroupLabel: 'Package group',
	parcelGroupWeightInfo: 'Kg per package group',
	parcelGroupWeightLabel: 'Group package by weight',
	paymentCardInputLabel: 'Please enter your credit card information to complete your order.',
	paymentFailError: 'Your payment was not successful! Please try again',
	paymentMethod: 'Payment method',
	paymentMethodBancontactLabel: 'Bancontact',
	paymentMethodBankcheckLabel: 'Bank check',
	paymentMethodBanktransferLabel: 'Bank transfer',
	paymentMethodCardLabel: 'Credit card',
	paymentMethodCreditcardLabel: 'Credit card',
	paymentMethodCreditDescription1: 'This amount is automatically deducted from the remaining amount to be paid from the total amount of your basket. ',
	paymentMethodGiropayLabel: 'Giropay',
	paymentMethodIdealLabel: 'iDEAL',
	paymentMethodPhoneLabel: 'Phone',
	paymentMethodCreditPay: 'Pay with my assets',
	paymentMethodCreditTitle: 'You have already paid part of your order:',
	paymentMethodCreditbalanceDescription1: 'Deducted automatically from your total',
	paymentMethodCreditbalanceDescription2: 'Left to pay',
	paymentMethodCreditbalancePay: 'Confirm with my credit',
	paymentMethodCreditbalanceTitle: 'Credit already applied',
	paymentValidButton: 'Pay now',
	previous: 'Previous',
	priceInformation: 'Price information',
	priceRoundAlertTooltip: 'This price may be rounded due to currency discussion',
	printButton: 'Print',
	process: 'Process',
	product: 'Product',
	productAdd: 'Add a product',
	productAdminListHint: 'Manage the catalogue, prices and shop availability.',
	productAnnexes: 'Appendices',
	productAnnexesNewProductError: 'Please register your new product first before adding annexes!',
	productAttributes: 'Attributes',
	productConversationTypeMissingAlert: 'There are no products associated with the selected type. Please contact us to resolve this issue!',
	productCostHT: 'Cost HT',
	productDescription: 'Description',
	productEdit: 'Edit product',
	productImages: 'Images',
	productImagesNewProductError: 'Please register your new product first before adding images!',
	productIsActive: 'Is active?',
	productName: 'Name',
	productPictureDelete: 'Delete image',
	productPriceHT: 'Price excluding tax. tax',
	productPriceTTC: 'Price incl. tax',
	productReference: 'Reference',
	productSlug: 'Slug',
	productSpecialPriceQuantityDiscountInfo: 'Save {percent}% on your cart by adding {quantity} copies!',
	productTaxCalculate: 'Calculate',
	productTaxRate: 'Tax Rate',
	productTaxRateFormHelp: 'For a 20% tax fill the tax rate at 0.2',
	productUseForConversationBook: 'Use for paper books?',
	productUseForConversationEBook: 'Use for E-books?',
	productUseForCredit: 'Use for user credits?',
	productUseForCustomization: 'Use for personalization?',
	products: 'Products',
	productsView: 'View Products',
	quantity: 'Quantity',
	refresh: 'Refresh',
	refundCreateConfirmMessage: 'Do you confirm the creation of this refund?',
	refundCreateTitle: 'Create a refund',
	remove: 'Delete',
	reset: 'Reset',
	retry: 'Start Over',
	save: 'Save',
	saveBeforeAlert: 'Please save first...',
	saveRequestError: 'Saving error!',
	saveRequestSuccess: 'Saved!',
	saving: 'Recording...',
	searchFor: 'Search for',
	seconds: 'Second(s)',
	select: 'Select',
	selectAll: 'Select all',
	selectFile: 'Select a file',
	selectImage: 'Select an image',
	selectOptions: 'Select an option',
	selectUnAll: 'Deselect all',
	seoOrderViewTitle: 'Order #{code}',
	seoTitle: 'Printing of SMS&Conversation in book',
	shippingAdd: 'Add a method',
	shippingAddressEdit: 'Change delivery address',
	shippingAddressMissingError: 'You have not entered your delivery address.',
	shippingAdminListHint: 'Configure carriers, countries and pricing rules for deliveries.',
	shippingCalculation: 'Calcul',
	shippingCalculationInfo: 'If the calculation is in a loop, it is better to use the inclusive maximum limit.',
	shippingCarrier: 'Transporteur',
	shippingChronopostPickupError: 'Unable to get pickup points! Verify your country & postal code, and retry',
	shippingChronopostPickupNoResult: 'We could not find any relay point near you. Please search with another address.',
	shippingChronopostPickupOpeningHours: "Horaires d'ouverture",
	shippingChronopostPickupOpeningHoursView: 'See opening hours',
	shippingChronopostPickupViewList: 'Voir la liste',
	shippingChronopostPickupViewMap: 'Voir la carte',
	shippingPickupError: 'Unable to open the pickup point selector. Please retry later.',
	shippingPickupChange: 'Change pickup point',
	shippingPickupChoose: 'Choose a pickup point',
	shippingCountrySelect: 'Delivery country',
	shippingDeleteConfirmMessage: 'Are you sure you want to delete this shipping method?',
	shippingDeliveryEstimationDate1: 'Estimated delivery date: {date}',
	shippingDeliveryEstimationDate2: 'Estimated delivery date: between {date1} and {date2}',
	shippingDeliveryEstimationText: 'This is an estimate of delivery costs. The selection of the delivery location will be made in the next step.',
	shippingDeliveryTime: 'Delivery time (in days)',
	shippingDeliveryTimeInfo: 'Delivery in {days} working days',
	shippingDescription: 'Description',
	shippingExcludeDepartmentInfo: 'Separate postal codes to exclude with a comma (,). Use "*" as a wildcard',
	shippingExcludeDepartmentLabel: 'Exclude postal codes',
	shippingExtraFeeCalculation: 'Calculation of additional shipping costs',
	shippingExtraFeeLabel: 'additional shipping cost label',
	shippingExtraFees: 'Additional fees',
	shippingFeeCalculatorTitle: 'Calculate your shipping costs',
	shippingFeeFreeDelivery: 'Free shipping',
	shippingFeeNotFoundError: '',
	shippingFeeWithBookResult: 'Order now and receive your ebook in minutes, then your paper books in {countryName} between {deliveryDateFrom} and {deliveryDateTo}',
	shippingFeeWithoutBookResult: 'Order now and receive your ebook in minutes',
	shippingFreeStep: 'Free delivery step',
	shippingFreeTreshold: 'Free shipping threshold',
	shippingFreeInfo: 'Free shipping from {value}',
	shippingIdentifier: 'Shipping ID',
	shippingIsPriceTTC: 'Does the shipping price include taxes?',
	shippingLabelGenerateButton: 'Generate label',
	shippingLabelGenerateButton2: 'Regenerate label',
	packingCheckTitle: 'Books in this order',
	packingCheckHint: 'Show one book at a time, back facing the camera. When the count moves, set it aside, out of view, then the next one.',
	packingCheckProgress: '{seen} / {expected}',
	packingCheckForeign: 'This book belongs to order {code}. Take it out of the parcel.',
	packingCheckReady: 'These are the right books. You can print the label.',
	packingCheckOverflow: 'Too many books were scanned. Start again.',
	packingCheckRestart: 'Start again',
	packingCheckCameraStart: 'Open the camera',
	packingCheckCameraDenied: 'The camera is blocked. Allow it, or scan with a barcode scanner.',
	packingCheckLocked: 'Scan every book before printing the label.',
	packingCheckWedgeLabel: 'Or scan the QR with a barcode scanner',
	packingCheckLoading: 'Loading the books for this order.',
	prepBooksCardTitle: 'Books',
	prepBooksCount: '{count, plural, one {# book} other {# books}}',
	prepBooksPageEyebrow: 'Preparation',
	prepBooksPageTitle: 'Order {code}',
	prepBooksPageHint: 'The books going in this parcel.',
	prepModeClient: 'Customer view',
	prepModePreparation: 'Preparation view',
	shippingMethod: 'Shipping method',
	shippingMethodCalculating: 'Calculating your costs...',
	shippingMethodConditions: 'Shipping Terms',
	shippingMethodMissingAlert: 'We do not have a valid carrier for your cart. Please modify your shipment to select a carrier',
	shippingMethodNotAvailable: 'No delivery method available for your address...',
	shippingRatesError: 'Something interrupted the delivery quote. Try again in a moment, and if it happens again, write to us and we\'ll look into it with you.',
	shippingMethodPricing: 'Tarif',
	shippingMethodPricingSystem: 'Pricing system',
	shippingMethodProviderData: 'Vendor information',
	shippingMethodSearch: 'Search for delivery methods',
	shippingMethodSelectTitle: 'Select Your Delivery',
	shippingGroupRelay: 'Pickup point',
	shippingGroupHome: 'Home delivery',
	shippingTierClassic: 'Standard delivery',
	shippingTierExpress: 'Express delivery',
	shippingTierClassicDesc: 'Standard delivery time',
	shippingTierExpressDesc: 'The fastest option',
	shippingTierPriceRelayFree: 'Free at pickup point',
	shippingTierPriceRelayFrom: 'From {price} at pickup point',
	shippingTierPriceHomeFrom: '{price} for home delivery',
	shippingChangeTier: 'Change delivery speed',
	shippingTierModeTitle: 'Choose your delivery mode',
	shippingStepOf: 'Step {current} of {total}',
	shippingStepSpeedTitle: 'When would you like to be delivered?',
	shippingStepModeTitle: 'Where would you like to be delivered?',
	shippingMethodTrackingInfo: 'Tracking Information',
	shippingMethods: 'Shipping methods',
	shippingOrder: 'Shipping Order',
	shippingProvider: 'Shipping Provider',
	shippingStep: 'Step',
	shippingStepInfo: 'This step MUST be the left setting! The top setting is the default zip code.',
	shippingStepLimitInfo: 'Is the condition left the minimum/maximum?',
	shippingTaxRate: 'Shipping Tax Rate',
	shippingTitle: 'Shipping',
	shippingTrackingNumber: 'Tracking Number',
	shippingTrackingParcelUrl: 'Shipping Tracking Package URL',
	status: 'Status',
	stepTitle: 'Step {step}',
	submit: 'Submit',
	suborderitemAddProductTitle: 'Add Product',
	switchLanguage: 'Change Language',
	tableDownloadNoElementError: 'Nothing to download!',
	tableMassActions: 'Bulk Actions',
	tablePageSize: 'Per page',
	tableRefreshSuccessAlert: 'Synchronized!',
	tableRefreshSuccessError: 'Error synchronizing!',
	tableSelection: `{count} {count, plural,
			  =0 {selected}
			  =1 {selected}
			  other {selected}
		  }`,
	tag: 'Keyword',
	tagFillPlaceholder: 'Enter a keyword...',
	tags: 'Keyword',
	taskAddTitle: 'Add a task',
	taskAssignSelf: 'Assign to me',
	taskCountdownDate: 'Reminder date',
	taskDescription: 'Description',
	taskEditTitle: 'Edit task',
	taskPriority: 'Priority',
	taxRate: 'VAT',
	the: 'the',
	time: 'Time',
	timezone: 'Time zone',
	title: 'Title',
	toleranceLabel: 'Tolerance',
	total: 'Total',
	type: 'Type',
	unit: 'Unit',
	unselect: 'Deselect',
	user: 'User',
	userAccountCreditsTitle: 'My credit balance',
	userAccountDataProtection: 'Data protection',
	userAccountDataProtectionText1: 'We take protection very seriously of your personal data, which is why we are committed to securing them and we keep them for a reasonable period of time necessary for the smooth running of the exams.',
	userAccountDataProtectionText2: 'We only ask you for information that is necessary for the service and we undertake to never communicate to a third party service or use your personal data for commercial purposes without your consent.',
	userAccountDataProtectionText3: 'If you wish to recover your data or use your right to data portability, please contact us at {email}',
	userAccountDelete: 'Delete my account',
	userAccountDeleteActiveSuborder: 'You cannot delete your account until the orders you are participating in have been completed!',
	userAccountDeleteBlockText: 'You cannot delete your account at this time!',
	userAccountDeleteButton: 'Delete my account',
	userAccountDeleteConfirmMessage: 'Are you sure you want to delete your account definitively?',
	userAccountDeleteConfirmTitle: 'Delete my account',
	userAccountDeleteError: 'Can not delete your account!',
	userAccountDeleteSuccess: 'Your account has been removed! Bye bye!',
	userAccountDeleteText: 'By deleting your account, you will remove your access to your information on this site. We will delete your personal data from our database. This action is irreversible!',
	userAccountEdit: 'Modify my account',
	userAccountEditSuccess: 'Account updated!',
	userAccountExistError: 'Your email address is not associated to an account!',
	userAccountExistTitle: 'Do you already have an account?',
	userAccountGeneral: 'General',
	userAccountHistory: 'History',
	userAccountInfo: 'Your data is protected and will remain strictly confidential.',
	userAccountInfoMyTitle: 'My information',
	userAccountMy: 'My account',
	userAccountNote: 'User account note',
	userAccountPersonnalInformation: 'My personal information',
	userAccountPreferencesInformation: 'My preferences',
	userAccountResetError: 'Error resetting account!',
	userAccountResetSuccess: 'Account reset!',
	userActivityOnLine: 'Online',
	userAdd: 'Add a new user',
	userAddNew: 'Add a new user',
	userAdminListHint: "Search accounts, view activity and open a profile or a user's orders.",
	userBridgeError: 'Sign-in from the application failed. Please try again.',
	userBridgeInvalid: 'This sign-in link is not valid anymore. Please start again from the application.',
	userBridgePending: 'Signing you in…',
	userBridgeSuccess: 'You are signed in! You can now go back to the application.',
	userCanCustomizeMessages: 'Can personalize messages?',
	userChangePasswordSuccess: 'Password successfully changed!',
	userConfirmationCode: 'Confirmation code received by email',
	userConfirmationCodeCheckButton: 'I received the code to reset my password',
	userConfirmationCodeError: 'Please check your email box to get the confirmation code...',
	userConnectionInfo: 'Access your account to validate your order and invite your friends to participate!',
	userCredits: 'Credits',
	userCreditsBalancePositive: 'You have {amount} in credit, applied automatically at the next step.',
	userCreditsPrepaymentInviteTitle: 'Prepaying your book',
	userDeleteConfirmMessage: 'Are you sure you want to delete this user?',
	userDeleteConfirmTitle: 'Delete user',
	userDeleteConfirmation: '{user} has been deleted!',
	userEdit: 'Edit {user}',
	userEdit2: 'Edit user',
	userEditPassword: 'Change my password',
	userEmail: 'Email',
	userEmailError: 'Your email address is incorrect!',
	userEmailFillInfo: 'Enter your email address',
	userEmailFormInfo: 'Enter your email to continue',
	userEmailFormInfo2: 'Your email will be used to create your account and alert you of updates to your order.',
	userLoginCodeTitle: 'You already have an account',
	userLoginCodeIntro: 'We just sent a 6-digit code to {email}. Enter it here to continue.',
	userLoginCodeLabel: 'Code received by email',
	userLoginCodeSubmit: 'Confirm',
	userLoginCodeInvalid: 'This code doesn\'t match. Check the latest email you received.',
	userLoginCodeExpired: 'This code is no longer valid. Ask for a new one below.',
	userLoginCodeError: 'Oops, that didn\'t work. Please try again in a moment.',
	userLoginCodeLinkHint: 'The same email also contains a sign-in link.',
	userLoginCodeResend: 'Send a new code',
	userLoginCodeResendIn: 'Send a new code in {seconds} s',
	userLoginCodeResent: 'Sent again. Remember to check your spam folder.',
	userLoginCodeChangeEmail: 'Use another email address',
	userLoginCodeCartSuccess: 'You\'re signed in. You can complete your order.',
	userEnvironmentTestNoTest: 'This user has not passed any environment tests!',
	userFillPlaceholder: 'Enter a user name...',
	userFirstName: 'Firstname',
	userForgotPassword: 'Forgot your password?',
	userForgotPasswordRetryDateError: 'You cannot request a password again. Please check your email to retrieve the confirmation code.',
	userFormInfo: 'Complete your profile',
	userGenderLabel: 'Gender',
	userIsActive: 'Active?',
	userLastName: 'Lastname',
	userLogAsUser: 'Log in as user',
	userLogin: 'Login',
	userLoginAction: 'Log in',
	userLoginBenefit1: 'Your SMS photo book in a few clicks',
	userLoginBenefit2: 'Fast home delivery',
	userLoginBenefit3: '100% secure payment',
	userLoginEmailSelected: 'Login with the email address: {email}',
	userLoginError: 'Wrong credentials! Please retry...',
	userLoginFirstButton: 'First connection?',
	userLoginFirstText: 'Check your mailbox to retrieve your temporary password. Use this password for your first connection. You can later change your password.',
	userLoginIntro: 'Please identify yourself to access your space',
	userLoginNoConnexion: 'Never logged in',
	userLoginTitle: 'Login',
	userLoginWelcomeSubtitle: 'Transform your SMS into a beautiful printed photo book.',
	userLoginWelcomeTitle: 'Welcome!',
	userLogout: 'Logout',
	userName: 'Name',
	userNewPassword: 'New password',
	userNewsletterSubscribeButton: 'Subscribe to the newsletter',
	userNewsletterSubscribeText: 'We will send you new products, promotions and our favorites',
	userNewsletterText1: 'Receive our news, good deals and promotions directly in your email box',
	userNewsletterTitle: 'Newsletter',
	userNewsletterUnSubscribeButton: 'Unsubscribe from the newsletter',
	userOldPassword: 'Old password',
	userOptions: 'User options',
	userOrdersView: 'View user orders',
	userPassword: 'Password',
	userPasswordConfirmation: 'Password confirmation',
	userPasswordConfirmationError: 'The password and the confirmation must be the same!',
	userPasswordConfirmationRestriction: 'The confirmation must be identical to the password entered',
	userPasswordEdit: 'Change my password',
	userPasswordSet: 'Set a password',
	userPasswordSetSuccess: 'Password saved.',
	userSocialConnectionsTitle: 'Sign-in methods',
	userSocialContinueApple: 'Continue with Apple',
	userSocialContinueGoogle: 'Continue with Google',
	userSocialDivider: 'or',
	userSocialError: 'Sign-in failed. Please try again.',
	userSocialErrorNoEmail: 'Your Apple account did not provide an email address. Use another sign-in method.',
	userSocialErrorUnavailable: 'This sign-in method is not available yet.',
	userSocialLinkApple: 'Link Apple',
	userSocialLinkGoogle: 'Link Google',
	userSocialLinkSuccess: 'Account linked.',
	userSocialLinked: 'Linked',
	userSocialUnlinkApple: 'Unlink Apple',
	userSocialUnlinkConfirm: 'Unlink this sign-in method from your account?',
	userSocialUnlinkGoogle: 'Unlink Google',
	userSocialUnlinkLastError: 'Add a password before unlinking your last sign-in method.',
	userSocialUnlinkSuccess: 'Account unlinked.',
	userPasswordError: 'Please enter a correct password!',
	userPasswordResetText: 'Please enter your personal password. Confirm it and click on the button below.',
	userPasswordRestriction: 'The password must have 8 characters and at least must have a special character (@&!()$*€%)!',
	userPasswordRestrictionAlt: 'The password must have 6 characters!',
	userPasswordTemporaryCheckButton: 'I received my temporary password',
	userPhone: 'Telephone',
	userPhoneError: 'Your telephone number is invalid!',
	userProfileMy: 'My profile',
	userReInitPassword: 'Reset my password',
	userRecoverFromOldAppCheckButton: 'I received my email to recover my password',
	userRecoverFromOldAppText: 'Your account has just been migrated to the new application! Check your mailbox to retrieve your password and activate your new account!',
	userRegister: 'Create my account',
	userRegisterError: 'Something went wrong...Please check your email address and retry!',
	userRegisterSuccess: 'Congratulations! Your account has been created! You will receive an email containing your temporary password!',
	userRegisterSuccessEmailNotice: 'A confirmation email has just been sent to {email}.',
	userRegisterSuccessEyebrow: 'Welcome',
	userRegisterSuccessPageTitle: 'Welcome!',
	userRegisterSuccessSourcesHint: 'Choose the app where your messages live.',
	userRegisterSuccessSourcesTitle: 'Where shall we start?',
	userRegisterSuccessStep1Desc: 'You will find a summary of your registration there.',
	userRegisterSuccessStep1Title: 'Check your inbox',
	userRegisterSuccessStep2Desc: 'WhatsApp, Messenger, Instagram, iOS or Android: pick your source.',
	userRegisterSuccessStep2Title: 'Import your messages',
	userRegisterSuccessStep3Desc: 'Cover, colours, photos: make it yours.',
	userRegisterSuccessStep3Title: 'Create your book',
	userRegisterSuccessStepsEyebrow: 'Your journey',
	userRegisterSuccessText: 'Your account is ready. In just a few steps, turn your messages into a book to treasure.',
	userRegisterSuccessTitle: 'Your story starts here',
	userRegisterSuccessTitleNamed: 'Welcome, {firstName}!',
	userResetPasswordAccountButton: 'Reset account password',
	userResetPasswordAskSuccess: 'Check your email to click on the link to reset your password!',
	userResetPasswordButton: 'Reset my password',
	userResetPasswordError: 'Unable to reset your password! Please retry...',
	userResetPasswordInfo: 'You will receive a confirmation link in your mailbox to reset your password.',
	userResetPasswordInfo2: 'Reset your password by filling in the fields below:',
	userResetPasswordSuccess: 'Password reset successed!',
	userRole: 'Role',
	userRoleAdmin: 'Administrator',
	userRoleCustomer: 'Customer',
	userSearchLabel: 'Type an email or user name',
	userSendNewAccountEmail: 'Send a new account email to the user',
	userSendNewAccountEmailSuccess: 'User alerted!',
	userSwitch: 'Change user',
	userValidForgotPasswordError: 'Unable to send you a reset password code!',
	userValidForgotPasswordSuccess: 'Check your email box to use the confirmation code to reset your password!',
	users: 'Users',
	usersList: 'User list',
	valid: 'Confirm',
	vatExempt: 'VAT EXEMPT',
	vatRates: 'VAT by country',
	vatRatesAddCountry: 'Add a country',
	vatRatesAdminHint: 'One VAT rate per delivery country. The price paid by the customer never changes.',
	vatRatesEmpty: 'No country configured: every order is invoiced at 0% VAT.',
	vatReport: 'VAT report',
	vatReportAdminHint: 'VAT invoiced by country over a period, ready for the tax return.',
	vatReportUnknownCountry: 'Unknown country',
	vatRatesIntro: 'The rate applied is the one of the delivery country (billing country for a digital only cart). The price paid stays identical: only the split between net price and VAT changes.',
	vatRatesIntroFallback: 'A country that is not in this table is invoiced at 0% VAT. The same rate applies to the printed book, the ebook and the shipping fee.',
	vatRatesInvalid: 'Check the rate of {country}: fill a percentage between 0 and 100.',
	vatRatesSaveSuccess: 'VAT rates saved!',
	vatRatesSimulation: 'Simulation on a price incl. tax',
	view: 'View',
	voucher: 'Voucher',
	voucherAdd: 'Add a voucher',
	voucherAdminListHint: 'Create and manage promo codes, conditions and usage limits.',
	voucherApplyButton: 'Apply',
	voucherApplyComplete: "You do not can't add another discount coupon!",
	voucherApplyFormLabel: 'Promo code',
	voucherApplyValidError: 'This coupon could not be applied to your order!',
	voucherCode: 'Code',
	voucherCodePlaceholder: 'Type your voucher code',
	voucherDeleteConfirmMessage: 'Are you sure you want to delete this voucher?',
	voucherEdit: 'Edit voucher',
	voucherIsAuto: 'Is auto?',
	voucherIsCumulative: 'Is cumulative?',
	voucherIsPublic: 'Is public?',
	voucherNotExistsError: 'This coupon does not exist!',
	voucherPriority: 'Priority',
	voucherProductOffer: 'Featured',
	voucherRemoveAllButton: 'Remove all promo codes',
	vouchers: 'Vouchers',
	weight: 'Weight',
	yes: 'Yes',
	you: 'You',
	yourself: 'You',
	offerErrorRequired: 'Please fill in the required fields.',
	offerErrorEmail: 'Please check your email address.',
	offerErrorGiftEmail: 'Please check the recipient\'s email address.',
	offerErrorGiftSameEmail: 'The recipient\'s email must be different from yours.',
	offerErrorGeneric: 'Oops, that didn\'t work. Please try again in a moment.',
	offerStepWhoEyebrow: 'Let\'s go',
	offerStepWhoTitle: 'Who will create the book?',
	offerStepWhoHint: 'You put it together yourself, for you or to give away. A gift card is for when they create it.',
	offerWhoSelf: 'I\'ll create it',
	offerWhoSelfHint: 'For me, or to give once it\'s printed',
	offerWhoGift: 'I\'ll give a gift card',
	offerWhoGiftHint: 'They get a link and create their own book',
	offerStepOccasionEyebrow: 'The occasion',
	offerStepOccasionHint: 'The moment you have in mind.',
	offerStepGiftEyebrow: 'Your gift',
	offerStepGiftTitle: 'Who are you giving it to?',
	offerStepGiftHint: 'We send the gift by email, with a link to create the book. Nothing to print, nothing to wrap.',
	offerGiftName: 'Their first name',
	offerGiftEmail: 'Their email',
	offerGiftEmailHelp: 'The gift lands in this inbox right after payment.',
	offerGiftFromName: 'Your first name',
	offerGiftFromNameHelp: 'So they know who it\'s from.',
	offerGiftMessage: 'A little note (optional)',
	offerGiftMessagePlaceholder: 'So these messages stay close to you, always.',
	offerContinue: 'Continue',
	offerStepMessengerEyebrow: 'Your messages',
	offerStepMessengerTitleGift: 'Where are the messages for {name}\'s book?',
	offerStepMessengerTitle: 'Where are your most beautiful messages?',
	offerStepMessengerHint: 'Pick one. You can change it later.',
	offerStepMessengerHintGift: 'Your conversation with {name}, or theirs with a loved one. Not sure which app? {name} can choose another one.',
	offerStepEmailEyebrow: 'Almost there',
	offerStepEmailTitle: 'Your account',
	offerStepEmailHintGift: 'Google, Apple, or your email. We send a confirmation, then you pay for the gift card.',
	offerStepEmailHint: 'Google, Apple, or your email. We send a confirmation, then you import the conversation.',
	offerStepEmailHintPay: 'Google, Apple, or your email. We send a confirmation, then you pay for the book.',
	offerEmailLabel: 'Email address',
	offerEmailPlaceholder: 'you@example.com',
	offerEmailSubmit: 'Continue to payment',
	offerEmailSubmitAccount: 'Create my account',
	offerEmailPrivacy: 'Just your book. Check your spam folder too.',
	offerStepSentEyebrow: 'Good to see you again',
	offerStepSentTitle: 'You already have an account',
	offerStepSentCodeHint: 'We just sent a 6-digit code to {email}. Enter it here: your order is waiting, ready to pay. Check your spam folder too.',
	offerStepSentCodeHintAccount: 'We just sent a 6-digit code to {email}. Enter it here to open your account and start the book. Check your spam folder too.',
	offerStepPayEyebrow: 'Last step',
	offerStepPayTitleGift: '{name}\'s book',
	offerStepPayTitle: 'Your printed book',
	offerLoggedAs: 'Signed in as {email}',
	offerSwitchAccount: 'Not you?',
	offerTrustReviews: '{count}+ reviews on Trustpilot',
	offerTrustGuarantee: 'Money-back guarantee',
	offerTrustShipping: 'Free delivery',
	offerPageTitle: 'Your book of messages',
	offerBack: 'Back',
	offerItemName: 'Printed book, ready to customize',
	offerPayBenefitBook: 'Your printed book, laid out with your messages and photos',
	offerPayBenefitBookGift: 'A real printed book, with the messages and photos of their choice',
	offerPayBenefitMedia: 'Voice notes and videos too, to relive through printed QR codes',
	offerPayBenefitCustom: 'Cover, photo, title, colors, preface: everything can be personalized',
	offerPayBenefitPdf: 'The PDF, free with your book',
	offerPayBenefitShipping: 'Free delivery',
	offerPayTotal: 'Total',
	offerPayNextGift: 'Right after payment, {name} receives your gift by email.',
	offerPayNextSelf: 'Right after payment, you import the conversation. A few minutes.',
	offerPayDreamSelf: 'The messages you keep rereading on your phone, soon in your hands. Forever.',
	offerPayDreamGift: 'The day {name} opens it, all these messages will come to life in their hands.',
	offerPayButton: 'Pay {price}',
	offerPaySecure: 'Secure payment. No subscription.',
	offerConfirmStepsTitle: 'How it works',
	offerConfirmGiftStep1: '{name} opens the email and clicks the link',
	offerConfirmGiftStep2: '{name} imports the conversation in a few minutes',
	offerConfirmGiftStep3: 'We print the book and deliver it',
	offerConfirmGiftTitle: 'Sent to {name}!',
	offerConfirmGiftLead: '{name} just received your gift at {email}, with a link to create the book. It\'s already paid for, delivery included.',
	offerConfirmViewOrder: 'View my order',
	offerConfirmGiftNote: 'Not received? Ask them to check their spam folder, or write to us.',
	offerConfirmStep1: 'Export your conversation from {messenger}',
	offerConfirmStep1Generic: 'Export your conversation from your messaging app',
	offerConfirmStep2: 'Import it here: we take care of the whole layout',
	offerConfirmStep3: 'Approve your book: we print it and ship it to you',
	offerConfirmTitle: 'Well done, your book is paid for!',
	offerConfirmLead: 'Just one thing left: import your {messenger} conversation. We\'ll guide you step by step, it only takes a few minutes.',
	offerConfirmLeadGeneric: 'Just one thing left: import your conversation. We\'ll guide you step by step, it only takes a few minutes.',
	offerConfirmCta: 'Import my {messenger} conversation',
	offerConfirmCtaGeneric: 'Import my conversation',
	offerConfirmChangeMessenger: 'My messages are on another app',
	offerConfirmEmailNote: 'Your receipt and login link were sent to {email}.',
	userMagicTitle: 'Sign in',
	userMagicWorking: 'Signing you in…',
	userMagicExpired: 'This link has expired. Get a new one in one click.',
	userMagicInvalid: 'This link is no longer valid. Get a new one in one click.',
	userMagicSent: 'If an account exists with this address, a new link is on its way. Remember to check your spam folder.',
	userMagicEmailLabel: 'Your email address',
	userMagicSend: 'Get a new link',
	conversationPreviewBookCreditRemaining: '+{price}',
	conversationPreviewIncluded: 'Included',
	conversationPreviewCollectionPrepaidNote: '{count} volumes · {paid} already paid for',
	conversationPreviewBookCreditBannerBestof: 'Your book is already paid for: the Best Of is included. Prefer the full collection? You only pay the difference.',
	conversationPreviewBookCreditBanner: 'Your book is already paid for, standard delivery included. Customize it, then complete your order.',
	conversationOrderButtonBookCreditRemaining: 'Complete my book · {price} left to pay',
	conversationOrderButtonBookCreditIncluded: 'Complete my book · Included',
	conversationPreviewBookCreditOrderHint: '{credit} already paid · catalogue price {fullPrice}',
	conversationOrderButtonBookCredit: 'Complete my book',
	conversationPreviewStickyBookCredit: 'Book already paid for',
	paymentMethodBookCreditHint: 'Your book is already paid for',
	cartTotalsBookCredit: 'Book already paid for',
	paymentMethodBookcredit: 'Prepaid book',
  },
};
